/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type activityType_enum = "Clinic" | "Race" | "Ride" | "%future added value";
export type HostEventProviderQueryVariables = {
    cuid: string;
    organizerSlug: string;
};
export type HostEventProviderQueryResponse = {
    readonly event_connection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly publishedAt: string | null;
                readonly activity: activityType_enum;
                readonly eventMetadata: {
                    readonly isCategoriedEvent: boolean;
                };
                readonly " $fragmentRefs": FragmentRefs<"HostEventPage_event" | "HostEventMainView_event" | "ValidityChecker_event" | "HeaderContainer_event" | "rulesDates_RuleEventEndAfterRegClose_event" | "rulesDates_RuleScheduleDatesInsideEventDate_event" | "rulesCategories_RuleAllCategoriesHaveCourse_event" | "helpers_useSyncSectionValidity_event" | "helpers_getUserTypeFromActivity_event" | "helpers_getEventActivity_event" | "helpers_getEventCuid_event" | "helpers_getEventSlug_event" | "helpers_getEventLink_event" | "helpers_useUpdateAlgoliaSearchIndexes_event" | "helpers_getEncodedEventId_event" | "helpers_getEncodedEventMetadataId_event" | "helpers_getIsEventPublished_event" | "helpers_getOrganizerCuid_event" | "hostEventMutations_useUnPublishEventMutation_event" | "EditEventNameDialog_event" | "OccurrencesDialog_event" | "OccurrenceInfo_event" | "CustomQuestionsContainer_event" | "SaveCustomQuestionDialog_event" | "IntroSection_event" | "GeneralSection_event" | "generalSectionSideEffects_event" | "LocationContactSection_event" | "VirtualVenueContainer_event" | "CourseSection_event" | "ProgramSection_event" | "AssessmentSection_event" | "ChecklistSection_event" | "VibeSection_event" | "SeriesSection_event" | "SanctionSection_event" | "TicketsSection_event" | "CategoryPresetContainer_event" | "CategoriesSection_event" | "CreateCategoryDialog_event" | "EditMultipleCategories_event" | "CoursesColumn_event" | "categoriesSectionSideEffects_scheduleItemOnCategoryDelete_event" | "categoriesSectionSideEffects_customQuestionOnCategoryDelete_event" | "categoriesSectionSideEffects_eventSanctionOnCategoryDelete_event" | "categoriesSectionSideEffects_eventSeriesOnCategoryDelete_event" | "categoriesSectionSideEffects_eventBasicWaiverOnCategoryDelete_event" | "DisciplineTabContainer_event" | "DisciplineTable_event" | "VolunteersSection_event" | "MerchandiseSection_event" | "RegistrationSection_event" | "EventCapacityContainer_event" | "PromoCodesContainer_event" | "PricingSection_event" | "ScheduleSection_event" | "ScheduleTypePicker_event" | "ImagesSection_event" | "AmenitiesSection_event" | "AwardsSection_event" | "SponsorsSection_event" | "AdditionalInfoSection_event" | "WaiverSection_event" | "BasicWaiverSection_event" | "ScheduleClinicSection_event" | "ScheduleClinicDialog_event" | "ScheduleRideSection_event" | "ScheduleRideDialog_event" | "FinishSection_event">;
            };
        }>;
    };
    readonly sanction_connection: {
        readonly " $fragmentRefs": FragmentRefs<"SanctionSection_sanctions">;
    };
    readonly sponsor_connection: {
        readonly " $fragmentRefs": FragmentRefs<"SponsorTierItem_sponsors">;
    };
    readonly scheduleTypePreset_connection: {
        readonly " $fragmentRefs": FragmentRefs<"SaveScheduleItemDialog_scheduleTypePreset">;
    };
    readonly amenity_connection: {
        readonly " $fragmentRefs": FragmentRefs<"AmenitiesSection_amenities">;
    };
    readonly globalPresetWaivers: {
        readonly " $fragmentRefs": FragmentRefs<"WaiverSection_waiverConnection">;
    };
};
export type HostEventProviderQuery = {
    readonly response: HostEventProviderQueryResponse;
    readonly variables: HostEventProviderQueryVariables;
};



/*
query HostEventProviderQuery(
  $cuid: String!
  $organizerSlug: String!
) {
  event_connection(where: {cuid: {_eq: $cuid}}) {
    edges {
      node {
        ...HostEventPage_event
        ...HostEventMainView_event
        ...ValidityChecker_event
        ...HeaderContainer_event
        ...rulesDates_RuleEventEndAfterRegClose_event
        ...rulesDates_RuleScheduleDatesInsideEventDate_event
        ...rulesCategories_RuleAllCategoriesHaveCourse_event
        ...helpers_useSyncSectionValidity_event
        ...helpers_getUserTypeFromActivity_event
        ...helpers_getEventActivity_event
        ...helpers_getEventCuid_event
        ...helpers_getEventSlug_event
        ...helpers_getEventLink_event
        ...helpers_useUpdateAlgoliaSearchIndexes_event
        ...helpers_getEncodedEventId_event
        ...helpers_getEncodedEventMetadataId_event
        ...helpers_getIsEventPublished_event
        ...helpers_getOrganizerCuid_event
        ...hostEventMutations_useUnPublishEventMutation_event
        ...EditEventNameDialog_event
        ...OccurrencesDialog_event
        ...OccurrenceInfo_event
        ...CustomQuestionsContainer_event
        ...SaveCustomQuestionDialog_event
        ...IntroSection_event
        ...GeneralSection_event
        ...generalSectionSideEffects_event
        ...LocationContactSection_event
        ...VirtualVenueContainer_event
        ...CourseSection_event
        ...ProgramSection_event
        ...AssessmentSection_event
        ...ChecklistSection_event
        ...VibeSection_event
        ...SeriesSection_event
        ...SanctionSection_event
        ...TicketsSection_event
        ...CategoryPresetContainer_event
        ...CategoriesSection_event
        ...CreateCategoryDialog_event
        ...EditMultipleCategories_event
        ...CoursesColumn_event
        ...categoriesSectionSideEffects_scheduleItemOnCategoryDelete_event
        ...categoriesSectionSideEffects_customQuestionOnCategoryDelete_event
        ...categoriesSectionSideEffects_eventSanctionOnCategoryDelete_event
        ...categoriesSectionSideEffects_eventSeriesOnCategoryDelete_event
        ...categoriesSectionSideEffects_eventBasicWaiverOnCategoryDelete_event
        ...DisciplineTabContainer_event
        ...DisciplineTable_event
        ...VolunteersSection_event
        ...MerchandiseSection_event
        ...RegistrationSection_event
        ...EventCapacityContainer_event
        ...PromoCodesContainer_event
        ...PricingSection_event
        ...ScheduleSection_event
        ...ScheduleTypePicker_event
        ...ImagesSection_event
        ...AmenitiesSection_event
        ...AwardsSection_event
        ...SponsorsSection_event
        ...AdditionalInfoSection_event
        ...WaiverSection_event
        ...BasicWaiverSection_event
        ...ScheduleClinicSection_event
        ...ScheduleClinicDialog_event
        ...ScheduleRideSection_event
        ...ScheduleRideDialog_event
        ...FinishSection_event
        id
        publishedAt
        activity
        eventMetadata {
          isCategoriedEvent
          id
        }
      }
    }
  }
  sanction_connection(order_by: {id: asc}) {
    ...SanctionSection_sanctions
  }
  sponsor_connection(order_by: {created_at: asc}, where: {_and: [{deleted_at: {_is_null: true}}, {organizer: {slug: {_eq: $organizerSlug}}}]}) {
    ...SponsorTierItem_sponsors
  }
  scheduleTypePreset_connection(order_by: [{activity: desc}, {id: asc}]) {
    ...SaveScheduleItemDialog_scheduleTypePreset
  }
  amenity_connection(order_by: {id: asc}) {
    ...AmenitiesSection_amenities
  }
  globalPresetWaivers: waiver_connection(where: {_and: {deleted_at: {_is_null: true}, ownerType: {_eq: REGGY}}}) {
    ...WaiverSection_waiverConnection
  }
}

fragment AdditionalInfoSection_event on event {
  id
  cuid
  activity
  description
  eventWebsite
  refundInfo
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    entryFee
    id
  }
  clinics(where: {canceledAt: {_is_null: true}}) {
    priceOverride
    id
  }
  rides(where: {canceledAt: {_is_null: true}}) {
    priceOverride
    id
  }
  eventPrograms {
    defaultPrice
    id
  }
  eventMetadata {
    isCategoriedEvent
    id
  }
  eventAdditionalInfos {
    id
    cuid
    title
    description
  }
}

fragment AmenitiesSection_amenities on amenityConnection {
  edges {
    node {
      id
      cuid
      name
      info
      imageUrl
    }
  }
}

fragment AmenitiesSection_event on event {
  id
  cuid
  activity
  eventAmenities {
    id
    cuid
    amenityCuid
  }
}

fragment AssessmentSection_event on event {
  id
  cuid
}

fragment AwardsSection_event on event {
  id
  cuid
  activity
  isSponsoredEvent
}

fragment BasicWaiverSection_event on event {
  id
  cuid
  activity
  hasGeneralWaivers
  publishedAt
  organizerCuid
  eventMetadata {
    isCategoriedEvent
    id
  }
  organizer {
    events(where: {deleted_at: {_is_null: true}}) {
      eventBasicWaivers(distinct_on: [name]) {
        id
        name
        fileRef
        cuid
      }
      id
    }
    id
  }
  eventBasicWaivers(order_by: {created_at: asc}) {
    id
    name
    fileRef
    cuid
    appliesToAllCategories
    eventBasicWaiverCategories {
      id
      cuid
      categoryCuid
      eventBasicWaiverCuid
    }
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
    cuid
    name
    eventDiscipline {
      id
      disciplineName
    }
  }
}

fragment CategoriesSection_event on event {
  id
  cuid
  name
  organizerCuid
  created_at
  slug
  publishedAt
  organizer {
    slug
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
  eventDisciplines(order_by: {created_at: asc}) {
    id
    cuid
    disciplineName
    fieldLimit
    courses {
      id
    }
    categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
      id
    }
  }
}

fragment CategoryPresetContainer_event on event {
  id
  cuid
  activity
  organizer {
    slug
    stripeConnectAccount {
      chargesEnabled
      payoutsEnabled
      id
    }
    id
  }
  courses(order_by: {created_at: asc}) {
    cuid
    eventDisciplineCuid
    fullName
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
    cuid
    additionalPrizes
    ageAsOf
    description
    entryFee
    eventDisciplineCuid
    eventCuid
    gender
    maxAge
    minAge
    name
    position
    abilityLevelRange
    spotsAvailable
    visible
    eventDiscipline {
      id
      disciplineName
    }
    eventScheduleCategories {
      id
      cuid
      eventScheduleCuid
    }
    categoryCourses {
      id
      cuid
      courseCuid
      category {
        name
        id
      }
    }
  }
}

fragment ChecklistSection_event on event {
  id
  cuid
  activity
  eventChecklistItems {
    id
    cuid
    name
    info
  }
}

fragment CourseSection_event on event {
  id
  cuid
  name
  activity
  isCourseEvent
  organizerCuid
  eventMetadata {
    isCategoriedEvent
    id
  }
  courses(order_by: {created_at: asc}) {
    id
    platform
    platformId
    platformUrl
    cuid
    name
    fullName
    description
    difficultyName
    eventDisciplineCuid
    eventCuid
    courseLength
    courseLengthType
    courseLengthSecondary
    courseLengthTypeSecondary
    totalElevationGain
    totalElevationLoss
    elevationUnit
    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {
      category {
        registrationCategories_aggregate(where: {registration: {status: {_eq: complete}}}) {
          aggregate {
            count
          }
        }
        id
      }
      id
    }
    eventDiscipline {
      id
      disciplineName
    }
  }
  eventDisciplines(order_by: {created_at: asc}) {
    id
    cuid
    disciplineName
    courses {
      id
    }
  }
}

fragment CoursesColumn_event on event {
  courses(order_by: {created_at: asc}) {
    id
    cuid
    name
    fullName
    eventDisciplineCuid
    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {
      id
      cuid
      courseCuid
      categoryCuid
    }
  }
}

fragment CreateCategoryDialog_event on event {
  id
  cuid
  currencyCode
  organizer {
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
  courses(order_by: {created_at: asc}) {
    id
    cuid
    name
    fullName
    eventDisciplineCuid
    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {
      id
      cuid
      courseCuid
      categoryCuid
    }
  }
}

fragment CustomQuestionsContainer_event on event {
  id
  cuid
  activity
  eventCustomQuestions(order_by: {position: asc}) {
    id
    cuid
    eventCuid
    internalPurpose
    additionalInfo
    isRequired
    questionType
    title
    position
    appliesToAllCategories
    eventCustomQuestionCategories(where: {category: {deleted_at: {_is_null: true}}}) {
      id
      cuid
      categoryCuid
      eventCustomQuestionCuid
      category {
        id
        name
      }
    }
    eventCustomQuestionOptions(order_by: {position: asc}) {
      id
      cuid
      name
      position
      eventCustomQuestionCuid
    }
  }
}

fragment DisciplineTabContainer_event on event {
  id
  cuid
  courses(order_by: {created_at: asc}) {
    id
    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {
      id
      cuid
    }
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
    cuid
    additionalPrizes
    ageAsOf
    description
    entryFee
    eventDisciplineCuid
    eventCuid
    gender
    maxAge
    minAge
    name
    position
    abilityLevelRange
    spotsAvailable
    visible
    registrationCategories(where: {registration: {status: {_eq: complete}}}, limit: 1) {
      id
    }
    eventScheduleCategories {
      id
      cuid
      eventScheduleCuid
    }
    categoryCourses {
      id
      cuid
      courseCuid
      categoryCuid
    }
  }
}

fragment DisciplineTable_event on event {
  id
  cuid
  currencyCode
  startDate
  organizer {
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
}

fragment EditEventNameDialog_event on event {
  cuid
  eventMetadata {
    cuid
    name
    slug
    isCategoriedEvent
    organizer {
      slug
      cuid
      id
    }
    id
  }
}

fragment EditMultipleCategories_event on event {
  id
  cuid
  currencyCode
  organizer {
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
  courses(order_by: {created_at: asc}) {
    id
    cuid
    name
    fullName
    eventDisciplineCuid
    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {
      id
      cuid
      courseCuid
      categoryCuid
    }
  }
}

fragment EventCapacityContainer_event on event {
  cuid
  spotsAvailable
  organizer {
    slug
    id
  }
  completeAndInProgressRegistrations: registrations_aggregate(where: {_and: [{status: {_in: [complete, in_progress]}}, {_not: {registrationCategories: {categoryCuid: {_is_null: true}}}}]}) {
    aggregate {
      count
    }
  }
}

fragment FinishSection_event on event {
  isEventCreationComplete
}

fragment GeneralSection_event on event {
  id
  cuid
  activity
  currencyCode
  endDate
  startDate
  eventAccess
  organizerCuid
  publishedAt
  isVirtualEvent
  occurrenceLabel
  eventMetadata {
    name
    isCategoriedEvent
    numberOfDays
    id
  }
  eventVirtualVenues {
    timezone
    id
  }
  eventVenues {
    venue {
      timezone
      id
    }
    id
  }
  organizer {
    slug
    cuid
    id
  }
  clinics(where: {canceledAt: {_is_null: true}}) {
    id
    cuid
    clinicDays {
      startTime
      eventClinicDayDuration {
        duration
        id
      }
      id
    }
  }
  eventClinicDayDurations {
    id
    cuid
    dayNumber
    duration
  }
  eventDisciplines(order_by: {created_at: asc}) {
    id
    cuid
    disciplineName
    categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
      id
      name
      eventDiscipline {
        disciplineName
        id
      }
      registrationCategories(limit: 1) {
        id
      }
    }
    courses {
      id
      name
      cuid
      eventDiscipline {
        disciplineName
        id
      }
    }
  }
}

fragment HeaderContainer_event on event {
  activity
  startDate
  endDate
  lastSavedAt
  canceledAt
  isEventCreationComplete
  registrations_aggregate(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}]}) {
    aggregate {
      count
    }
  }
  eventMetadata {
    cuid
    name
    isCategoriedEvent
    events(where: {deleted_at: {_is_null: true}}) {
      cuid
      id
    }
    id
  }
}

fragment HostEventMainView_event on event {
  endDate
  activity
  canceledAt
  registrations_aggregate(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}]}) {
    aggregate {
      count
    }
  }
}

fragment HostEventPage_event on event {
  occurrenceLabel
  eventMetadata {
    name
    id
  }
}

fragment ImagesSection_event on event {
  id
  cuid
  activity
  eventImages(order_by: {position: asc}) {
    id
    cuid
    position
    eventCuid
    imagePublicId
    image {
      bytes
      format
      height
      originalFilename
      organizerCuid
      publicId
      relativeUrl
      resourceType
      url
      version
      width
      id
    }
  }
}

fragment IntroSection_event on event {
  occurrenceLabel
  eventMetadata {
    name
    id
  }
  activity
}

fragment LocationContactSection_event on event {
  id
  cuid
  isVirtualEvent
  additionalContactInfo
  activity
  email
  lastSavedAt
  organizerCuid
  name
  phone
  publishedAt
  eventMetadata {
    isCategoriedEvent
    id
  }
  eventVirtualVenues {
    cuid
    timezone
    id
  }
  eventVenues {
    id
    meetupInstructions
    additionalInfo
    campingDescription
    parkingInfo
    cuid
    eventCuid
    venue {
      id
      cuid
      name
      placeId
      lat
      lng
      organizerCuid
      fullAddress
      addressWithName
      address
      city
      state
      country
      countryCode
      postalCode
      timezone
    }
  }
}

fragment MerchandiseSection_event on event {
  id
  cuid
  currencyCode
  hasMerchandise
  eventMerchandises(where: {merchandise: {deleted_at: {_is_null: true}}}) {
    id
    visible
    availableTo
    cuid
    merchandise {
      id
      cuid
      title
      description
      deliveryType
      price
      stock
      merchandiseImages {
        id
        cuid
        isDefault
        image {
          bytes
          format
          height
          originalFilename
          publicId
          relativeUrl
          resourceType
          url
          version
          width
          organizerCuid
          id
        }
      }
      merchandiseVariantOptions {
        id
        cuid
        optionName
        merchandiseVariantOptionValues {
          id
          cuid
          value
          merchandiseVariantOptionCuid
        }
      }
      merchandiseVariants {
        id
        cuid
        merchandiseCuid
        optionCuidValueCuid
        stock
        price
        image {
          bytes
          format
          height
          originalFilename
          publicId
          relativeUrl
          resourceType
          url
          version
          width
          organizerCuid
          id
        }
      }
    }
  }
}

fragment OccurrenceInfo_event on event {
  organizerCuid
  occurrenceLabel
  endDate
  registrations_aggregate(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}]}) {
    aggregate {
      count
    }
  }
  eventMetadata {
    name
    id
  }
}

fragment OccurrencesDialog_event on event {
  organizerCuid
  eventMetadata {
    cuid
    events(where: {deleted_at: {_is_null: true}}) {
      cuid
      startDate
      endDate
      lastSavedAt
      canceledAt
      publishedAt
      cancellationReason
      occurrenceLabel
      registrations(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}, {event: {deleted_at: {_is_null: true}}}]}) {
        userId
        id
      }
      id
    }
    id
  }
}

fragment PricingSection_event on event {
  id
  cuid
  startDate
  endDate
  regOpenDate
  regCloseDate
  hasDynamicPricing
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
    cuid
    name
    entryFee
  }
  eventPricingDates(order_by: {date: asc}) {
    id
    cuid
    date
    eventCuid
  }
  eventPricingChanges {
    id
    cuid
    amount
    eventPricingDateCuid
    eventPricingGroupCuid
    eventCuid
  }
  eventPricingGroups {
    id
    cuid
    name
    eventCuid
    eventPricingGroupCategories {
      id
      cuid
      eventPricingGroupCuid
      categoryCuid
      category {
        id
        cuid
        name
        entryFee
      }
    }
  }
}

fragment ProgramSection_event on event {
  id
  cuid
  currencyCode
  organizer {
    stripeConnectAccount {
      chargesEnabled
      payoutsEnabled
      id
    }
    id
  }
  eventPrograms {
    id
    cuid
    overview
    skills
    focus
    genders
    ageRange
    abilityLevelRange
  }
}

fragment PromoCodesContainer_event on event {
  id
  cuid
  activity
  currencyCode
  regCloseDate
  regOpenDate
  eventMetadata {
    isCategoriedEvent
    id
  }
  eventPromoCodes {
    id
    cuid
    eventCuid
    amountOff
    percentOff
    code
    codesAvailable
    validFrom
    validTo
    isInactive
  }
  eventVenues {
    venue {
      timezone
      id
    }
    id
  }
  eventVirtualVenues {
    timezone
    id
  }
}

fragment RegistrationSection_event on event {
  id
  cuid
  activity
  startDate
  endDate
  regOpenDate
  regCloseDate
  selfEditEndDate
  isRegistrationPaused
  nonCategoriedRegDeadline
  eventMetadata {
    isCategoriedEvent
    id
  }
  eventVenues {
    venue {
      timezone
      id
    }
    id
  }
}

fragment SanctionSection_event on event {
  id
  cuid
  name
  activity
  publishedAt
  isSanctionedEvent
  organizerCuid
  eventMetadata {
    isCategoriedEvent
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
    cuid
    name
    eventDiscipline {
      id
      disciplineName
    }
  }
  eventSanctions {
    id
    cuid
    eventCuid
    otherSanctionName
    permit
    sanctionCuid
    appliesToAllCategories
    allowOneDayLicense
    isLicenseRequired
    oneDayFee
    eventSanctionCategories {
      id
      cuid
      categoryCuid
      eventSanctionCuid
    }
    sanction {
      id
      cuid
      name
      hasPermit
      waiverLink
      isOneDayAvailable
      country
      website
      oneDayFee
    }
  }
}

fragment SanctionSection_sanctions on sanctionConnection {
  edges {
    node {
      id
      cuid
      name
      hasPermit
      country
      isOneDayAvailable
      oneDayFee
      waiverLink
      website
    }
  }
}

fragment SaveCustomQuestionDialog_event on event {
  id
  cuid
  activity
  eventMetadata {
    isCategoriedEvent
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
    cuid
    name
    eventDiscipline {
      id
      disciplineName
    }
  }
}

fragment SaveScheduleItemDialog_scheduleTypePreset on scheduleTypePresetConnection {
  edges {
    node {
      id
      cuid
      type
      activity
      color
      isPreset
    }
  }
}

fragment ScheduleClinicDialog_event on event {
  id
  cuid
  activity
  currencyCode
  isVirtualEvent
  eventVirtualVenues {
    timezone
    id
  }
  eventVenues {
    venue {
      timezone
      id
    }
    id
  }
  eventClinicDayDurations {
    cuid
    dayNumber
    duration
    id
  }
  eventPrograms {
    defaultPrice
    ageRange
    id
  }
  organizer {
    slug
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    userOrganizerRoles {
      user {
        id
        firstName
        lastName
        timezone
        slug
        stripeConnectAccount {
          payoutsEnabled
          chargesEnabled
          id
        }
        coachCuid
        coach {
          id
          cuid
          user {
            firstName
            lastName
            timezone
            id
          }
          coachUnavailableDates {
            id
            cuid
            date
            startSeconds
            endSeconds
            isAllDay
          }
          coachAvailabilities {
            cuid
            dayOfTheWeek
            isAvailable
            startSeconds
            endSeconds
            id
          }
        }
      }
      id
    }
    id
  }
  clinics(where: {canceledAt: {_is_null: true}}) {
    clinicDays {
      startTime
      eventClinicDayDuration {
        duration
        id
      }
      id
    }
    id
  }
}

fragment ScheduleClinicSection_event on event {
  id
  cuid
  activity
  currencyCode
  isVirtualEvent
  organizer {
    slug
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
    userOrganizerRoles {
      user {
        id
        coach {
          id
        }
      }
      id
    }
  }
  eventClinicDayDurations {
    cuid
    dayNumber
    duration
    id
  }
  eventPrograms {
    id
    cuid
    defaultPrice
  }
  clinics(where: {canceledAt: {_is_null: true}}) {
    id
    cuid
    eventCuid
    priceOverride
    canceledAt
    cancellationReason
    spotsAvailable
    meetingLink
    registrationStatus
    registrations_aggregate(where: {status: {_eq: complete}}) {
      aggregate {
        count
      }
    }
    event {
      isVirtualEvent
      eventVirtualVenues {
        timezone
        id
      }
      eventVenues {
        venue {
          timezone
          id
        }
        id
      }
      eventPrograms {
        defaultPrice
        ageRange
        id
      }
      eventClinicDayDurations {
        cuid
        dayNumber
        duration
        id
      }
      organizer {
        userOrganizerRoles {
          user {
            id
            firstName
            lastName
            timezone
            slug
            coachCuid
            stripeConnectAccount {
              payoutsEnabled
              chargesEnabled
              id
            }
            coach {
              id
              cuid
              user {
                firstName
                lastName
                timezone
                id
              }
              coachUnavailableDates {
                id
                cuid
                date
                startSeconds
                endSeconds
                isAllDay
              }
              coachAvailabilities {
                cuid
                dayOfTheWeek
                isAvailable
                startSeconds
                endSeconds
                id
              }
            }
          }
          id
        }
        id
      }
      id
    }
    clinicDays {
      cuid
      startTime
      eventClinicDayDurationCuid
      eventClinicDayDuration {
        cuid
        dayNumber
        duration
        id
      }
      id
    }
    clinicCoaches {
      cuid
      clinicCuid
      coachCuid
      id
    }
  }
}

fragment ScheduleRideDialog_event on event {
  id
  cuid
  activity
  currencyCode
  occurrenceLabel
  isVirtualEvent
  eventMetadata {
    name
    numberOfDays
    id
  }
  organizer {
    slug
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
  eventVenues {
    venue {
      timezone
      id
    }
    id
  }
  rides(where: {canceledAt: {_is_null: true}}) {
    created_at
    priceOverride
    rideDays {
      startTime
      id
    }
    id
  }
}

fragment ScheduleRideSection_event on event {
  id
  cuid
  activity
  currencyCode
  organizer {
    slug
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
  startDate
  endDate
  eventVenues {
    venue {
      timezone
      id
    }
    id
  }
  eventVirtualVenues {
    timezone
    id
  }
  rides(where: {canceledAt: {_is_null: true}}) {
    id
    cuid
    eventCuid
    priceOverride
    canceledAt
    cancellationReason
    spotsAvailable
    registrationStatus
    dayOfContact
    registrations_aggregate(where: {status: {_eq: complete}}) {
      aggregate {
        count
      }
    }
    event {
      occurrenceLabel
      eventMetadata {
        name
        numberOfDays
        id
      }
      eventVenues {
        venue {
          timezone
          id
        }
        id
      }
      id
    }
    rideDays {
      cuid
      startTime
      id
    }
  }
}

fragment ScheduleSection_event on event {
  id
  cuid
  activity
  startDate
  eventVenues {
    venue {
      timezone
      id
    }
    id
  }
  eventVirtualVenues {
    timezone
    id
  }
  eventMetadata {
    isCategoriedEvent
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
    cuid
    name
    eventDiscipline {
      id
      disciplineName
    }
  }
  eventScheduleTypeCustoms {
    id
    cuid
    type
    color
    isPreset
  }
  eventScheduleDates(order_by: {date: asc}) {
    id
    cuid
    date
    dayNumber
    eventSchedules {
      id
      cuid
      title
      startTime
      endTime
      description
      addedInternally
      appliesToAllCategories
      eventScheduleDateCuid
      eventScheduleTypeCustom {
        id
        cuid
        type
        color
        isPreset
      }
      eventScheduleTypePreset {
        id
        cuid
        isPreset
        scheduleTypePresetCuid
        scheduleTypePreset {
          id
          cuid
          type
          color
          isPreset
        }
      }
      eventScheduleCategories {
        id
        cuid
        categoryCuid
        eventScheduleCuid
      }
    }
  }
}

fragment ScheduleTypePicker_event on event {
  activity
  eventScheduleTypeCustoms {
    id
    cuid
    eventCuid
    color
    isPreset
    type
  }
}

fragment SeriesSection_event on event {
  id
  cuid
  name
  activity
  publishedAt
  isSeriesEvent
  organizerCuid
  eventMetadata {
    isCategoriedEvent
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
    cuid
    name
    eventDiscipline {
      id
      disciplineName
    }
  }
  eventSeries(where: {deleted_at: {_is_null: true}}) {
    id
    cuid
    eventCuid
    seriesCuid
    roundNumber
    appliesToAllCategories
    eventSeriesCategories {
      id
      cuid
      categoryCuid
      eventSeriesCuid
    }
    event {
      id
      cuid
      occurrenceLabel
      eventMetadata {
        name
        isCategoriedEvent
        id
      }
    }
    series {
      id
      cuid
      name
      slug
      description
      seriesActivity
      organizerCuid
      totalRounds
      isJoinable
      joinKey
      eventSeries(where: {deleted_at: {_is_null: true}}) {
        id
        cuid
        eventCuid
        seriesCuid
        roundNumber
        appliesToAllCategories
        event {
          id
          cuid
          occurrenceLabel
          eventMetadata {
            name
            isCategoriedEvent
            id
          }
        }
        eventSeriesCategories {
          id
          cuid
          categoryCuid
          eventSeriesCuid
        }
      }
      seriesImages {
        isDefault
        id
        cuid
        image {
          bytes
          format
          height
          originalFilename
          publicId
          relativeUrl
          resourceType
          url
          version
          width
          organizerCuid
          id
        }
      }
      seriesPointsStructureCustoms {
        id
        cuid
        isPreset
        isQualifying
        points
        pointsName
      }
      seriesPointsStructurePresets {
        id
        presetCuid
        isPreset
      }
    }
  }
}

fragment SponsorTierItem_sponsors on sponsorConnection {
  edges {
    node {
      id
      cuid
      name
      website
      sponsorImages {
        id
        cuid
        isDefault
        image {
          id
          bytes
          format
          height
          originalFilename
          organizerCuid
          publicId
          relativeUrl
          resourceType
          url
          version
          width
        }
      }
    }
  }
}

fragment SponsorsSection_event on event {
  id
  cuid
  activity
  isSponsoredEvent
  eventSponsors(order_by: {position: asc}) {
    id
    cuid
    tierName
    position
    sponsor {
      id
      cuid
      name
      website
      sponsorImages {
        id
        cuid
        isDefault
        image {
          id
          bytes
          format
          height
          originalFilename
          organizerCuid
          publicId
          relativeUrl
          resourceType
          url
          version
          width
        }
      }
    }
  }
}

fragment TicketsSection_event on event {
  id
  cuid
  activity
  currencyCode
  isTicketedEvent
  organizer {
    slug
    stripeConnectAccount {
      payoutsEnabled
      chargesEnabled
      id
    }
    id
  }
  eventTickets(where: {deleted_at: {_is_null: true}}) {
    id
    cuid
    name
    description
    price
    ticketsAvailable
    visible
    eventCuid
    registrationTickets(where: {registration: {status: {_eq: complete}}}, limit: 1) {
      id
    }
  }
}

fragment ValidityChecker_event on event {
  eventMetadata {
    isCategoriedEvent
    id
  }
}

fragment VibeSection_event on event {
  id
  cuid
  eventMetadata {
    numberOfDays
    id
  }
  eventVibes {
    id
    cuid
    ridingTimePerDayRange
    abilityLevelRange
    hasAverageSpeed
    averageSpeedRange
    intensityRange
    moreInfo
    rideType
    speedType
    genders
  }
}

fragment VirtualVenueContainer_event on event {
  id
  cuid
  eventVirtualVenues {
    id
    cuid
    timezone
  }
}

fragment VolunteersSection_event on event {
  id
  cuid
  hasVolunteers
  eventVolunteerJobs(where: {deleted_at: {_is_null: true}}, order_by: [{title: asc}, {created_at: asc}]) {
    id
    cuid
    title
    description
    locationInfo
    eventCuid
    eventVolunteerJobTasks {
      id
      cuid
      volunteerTaskPriorityCuid
      volunteerTaskPriority {
        id
        cuid
        name
        chipColor
        className
        color
      }
      volunteerTaskDifficultyCuid
      volunteerTaskDifficulty {
        id
        cuid
        name
        chipColor
        className
        color
      }
      description
      eventVolunteerJobCuid
    }
    eventVolunteerJobShifts {
      id
      cuid
      name
      eventVolunteerJobCuid
      spotsAvailable
      startDate
      endDate
      eventVolunteerJobShiftTasks {
        id
        cuid
        eventVolunteerJobShiftCuid
        eventVolunteerJobTaskCuid
      }
    }
  }
}

fragment WaiverSection_event on event {
  id
  cuid
  activity
  hasGeneralWaivers
  publishedAt
  organizerCuid
  eventWaivers(where: {type: {_eq: GENERAL}, waiver: {deleted_at: {_is_null: true}}}) {
    waiver {
      id
      cuid
      ownerType
      latestRevision {
        id
        name
        fileRef
        cuid
        fieldsConfiguration
        revision
      }
    }
    id
  }
  sanctions: eventSanctions {
    cuid
    sanction {
      id
      cuid
      name
    }
    otherSanctionName
    eventWaivers {
      waiver {
        cuid
        id
        ownerType
        latestRevision {
          id
          name
          fileRef
          cuid
          fieldsConfiguration
          revision
        }
      }
      id
    }
    id
  }
}

fragment WaiverSection_waiverConnection on waiverConnection {
  edges {
    node {
      id
      cuid
      ownerType
      sanctionWaivers {
        sanction {
          name
          id
        }
        id
      }
      latestRevision {
        cuid
        fieldsConfiguration
        fileRef
        id
        name
        revision
      }
    }
  }
}

fragment categoriesSectionSideEffects_customQuestionOnCategoryDelete_event on event {
  id
  cuid
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
  }
  eventCustomQuestions(order_by: {position: asc}) {
    id
    cuid
    eventCuid
    internalPurpose
    additionalInfo
    isRequired
    questionType
    title
    position
    appliesToAllCategories
    eventCustomQuestionCategories(where: {category: {deleted_at: {_is_null: true}}}) {
      id
    }
  }
}

fragment categoriesSectionSideEffects_eventBasicWaiverOnCategoryDelete_event on event {
  id
  cuid
  activity
  eventMetadata {
    isCategoriedEvent
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
  }
  eventBasicWaivers(order_by: {created_at: asc}) {
    cuid
    name
    fileRef
    eventCuid
    appliesToAllCategories
    eventBasicWaiverCategories {
      id
      cuid
    }
    id
  }
}

fragment categoriesSectionSideEffects_eventSanctionOnCategoryDelete_event on event {
  id
  cuid
  activity
  eventMetadata {
    isCategoriedEvent
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
  }
  eventSanctions {
    cuid
    eventCuid
    sanctionCuid
    appliesToAllCategories
    eventSanctionCategories {
      id
      cuid
    }
    id
  }
}

fragment categoriesSectionSideEffects_eventSeriesOnCategoryDelete_event on event {
  id
  cuid
  activity
  eventMetadata {
    isCategoriedEvent
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
  }
  eventSeries(where: {deleted_at: {_is_null: true}}) {
    cuid
    eventCuid
    roundNumber
    seriesCuid
    appliesToAllCategories
    eventSeriesCategories {
      id
      cuid
    }
    id
  }
}

fragment categoriesSectionSideEffects_scheduleItemOnCategoryDelete_event on event {
  id
  cuid
  activity
  eventMetadata {
    isCategoriedEvent
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    id
  }
  eventScheduleDates(order_by: {date: asc}) {
    cuid
    eventSchedules {
      cuid
      title
      startTime
      endTime
      eventCuid
      eventScheduleDateCuid
      appliesToAllCategories
      eventScheduleCategories {
        id
        cuid
      }
      id
    }
    id
  }
}

fragment generalSectionSideEffects_event on event {
  id
  cuid
  activity
  endDate
  startDate
  eventMetadata {
    isCategoriedEvent
    id
  }
  eventScheduleDates(order_by: {date: asc}) {
    id
    cuid
    date
    dayNumber
    eventCuid
    eventSchedules {
      id
      cuid
      title
      startTime
      endTime
      eventCuid
      addedInternally
      eventScheduleDateCuid
      eventScheduleTypePreset {
        id
        cuid
        isPreset
        scheduleTypePresetCuid
        scheduleTypePreset {
          id
          cuid
          type
          color
          isPreset
        }
      }
    }
  }
}

fragment helpers_getEncodedEventId_event on event {
  id
}

fragment helpers_getEncodedEventMetadataId_event on event {
  eventMetadata {
    id
  }
}

fragment helpers_getEventActivity_event on event {
  activity
}

fragment helpers_getEventCuid_event on event {
  cuid
}

fragment helpers_getEventLink_event on event {
  cuid
  eventMetadata {
    slug
    id
  }
  organizer {
    slug
    id
  }
}

fragment helpers_getEventSlug_event on event {
  eventMetadata {
    slug
    id
  }
}

fragment helpers_getIsEventPublished_event on event {
  publishedAt
}

fragment helpers_getOrganizerCuid_event on event {
  organizerCuid
}

fragment helpers_getUserTypeFromActivity_event on event {
  activity
}

fragment helpers_useSyncSectionValidity_event on event {
  cuid
  activity
  startDate
  regCloseDate
  isVirtualEvent
  publishedAt
  currencyCode
  completedSections
  occurrenceLabel
  eventMetadata {
    isCategoriedEvent
    name
    id
  }
  organizer {
    cuid
    id
  }
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    entryFee
    id
  }
  rides(where: {canceledAt: {_is_null: true}}) {
    priceOverride
    id
  }
  clinics(where: {canceledAt: {_is_null: true}}) {
    priceOverride
    id
  }
  eventPrograms {
    defaultPrice
    id
  }
}

fragment helpers_useUpdateAlgoliaSearchIndexes_event on event {
  publishedAt
  eventMetadata {
    isCategoriedEvent
    id
  }
}

fragment hostEventMutations_useUnPublishEventMutation_event on event {
  registrations(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}, {event: {deleted_at: {_is_null: true}}}]}) {
    userId
    id
  }
}

fragment rulesCategories_RuleAllCategoriesHaveCourse_event on event {
  id
  cuid
  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {
    cuid
    name
    categoryCourses {
      id
      cuid
    }
    id
  }
}

fragment rulesDates_RuleEventEndAfterRegClose_event on event {
  id
  cuid
  activity
  endDate
  regCloseDate
}

fragment rulesDates_RuleScheduleDatesInsideEventDate_event on event {
  id
  cuid
  endDate
  startDate
  eventScheduleDates(order_by: {date: asc}) {
    cuid
    date
    dayNumber
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cuid"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizerSlug"
        } as any
    ], v1 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "_eq",
                            "variableName": "cuid"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "cuid"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publishedAt",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activity",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCategoriedEvent",
        "storageKey": null
    } as any, v6 = {
        "id": "asc"
    } as any, v7 = [
        {
            "kind": "Literal",
            "name": "order_by",
            "value": (v6 /*: any*/)
        } as any
    ], v8 = {
        "created_at": "asc"
    } as any, v9 = {
        "kind": "Literal",
        "name": "order_by",
        "value": (v8 /*: any*/)
    } as any, v10 = {
        "_is_null": true
    } as any, v11 = {
        "deleted_at": (v10 /*: any*/)
    } as any, v12 = [
        (v9 /*: any*/),
        {
            "fields": [
                {
                    "items": [
                        {
                            "kind": "Literal",
                            "name": "_and.0",
                            "value": (v11 /*: any*/)
                        },
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "fields": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "_eq",
                                                    "variableName": "organizerSlug"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "slug"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "organizer"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "_and.1"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "_and"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        } as any
    ], v13 = [
        {
            "kind": "Literal",
            "name": "order_by",
            "value": [
                {
                    "activity": "desc"
                },
                (v6 /*: any*/)
            ]
        } as any
    ], v14 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "_and": {
                    "deleted_at": (v10 /*: any*/),
                    "ownerType": {
                        "_eq": "REGGY"
                    }
                }
            }
        } as any
    ], v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "occurrenceLabel",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cuid",
        "storageKey": null
    } as any, v18 = {
        "kind": "Literal",
        "name": "where",
        "value": (v11 /*: any*/)
    } as any, v19 = [
        (v18 /*: any*/)
    ], v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startDate",
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endDate",
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastSavedAt",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canceledAt",
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cancellationReason",
        "storageKey": null
    } as any, v25 = {
        "status": {
            "_eq": "complete"
        }
    } as any, v26 = {
        "_or": [
            (v25 /*: any*/),
            {
                "status": {
                    "_eq": "canceled"
                }
            }
        ]
    } as any, v27 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "where",
                "value": {
                    "_and": [
                        (v26 /*: any*/),
                        {
                            "event": (v11 /*: any*/)
                        }
                    ]
                }
            }
        ],
        "concreteType": "registration",
        "kind": "LinkedField",
        "name": "registrations",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
            },
            (v2 /*: any*/)
        ],
        "storageKey": "registrations(where:{\"_and\":[{\"_or\":[{\"status\":{\"_eq\":\"complete\"}},{\"status\":{\"_eq\":\"canceled\"}}]},{\"event\":{\"deleted_at\":{\"_is_null\":true}}}]})"
    } as any, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfDays",
        "storageKey": null
    } as any, v30 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
        } as any
    ], v31 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "registration_aggregate_fields",
            "kind": "LinkedField",
            "name": "aggregate",
            "plural": false,
            "selections": (v30 /*: any*/),
            "storageKey": null
        } as any
    ], v32 = [
        {
            "kind": "Literal",
            "name": "order_by",
            "value": {
                "date": "asc"
            }
        } as any
    ], v33 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
    } as any, v34 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dayNumber",
        "storageKey": null
    } as any, v35 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventCuid",
        "storageKey": null
    } as any, v36 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v37 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startTime",
        "storageKey": null
    } as any, v38 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPreset",
        "storageKey": null
    } as any, v39 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v40 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    } as any, v41 = [
        (v2 /*: any*/),
        (v17 /*: any*/),
        (v39 /*: any*/),
        (v40 /*: any*/),
        (v38 /*: any*/)
    ], v42 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "appliesToAllCategories",
        "storageKey": null
    } as any, v43 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryCuid",
        "storageKey": null
    } as any, v44 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventScheduleCuid",
        "storageKey": null
    } as any, v45 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    } as any, v46 = {
        "kind": "Literal",
        "name": "order_by",
        "value": {
            "position": "asc"
        }
    } as any, v47 = [
        (v46 /*: any*/),
        (v18 /*: any*/)
    ], v48 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "courseCuid",
        "storageKey": null
    } as any, v49 = [
        (v16 /*: any*/),
        (v2 /*: any*/)
    ], v50 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entryFee",
        "storageKey": null
    } as any, v51 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "disciplineName",
        "storageKey": null
    } as any, v52 = {
        "alias": null,
        "args": null,
        "concreteType": "eventDiscipline",
        "kind": "LinkedField",
        "name": "eventDiscipline",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            (v51 /*: any*/)
        ],
        "storageKey": null
    } as any, v53 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventDisciplineCuid",
        "storageKey": null
    } as any, v54 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "position",
        "storageKey": null
    } as any, v55 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "abilityLevelRange",
        "storageKey": null
    } as any, v56 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spotsAvailable",
        "storageKey": null
    } as any, v57 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "visible",
        "storageKey": null
    } as any, v58 = {
        "kind": "Literal",
        "name": "limit",
        "value": 1
    } as any, v59 = {
        "kind": "Literal",
        "name": "where",
        "value": {
            "registration": (v25 /*: any*/)
        }
    } as any, v60 = [
        (v58 /*: any*/),
        (v59 /*: any*/)
    ], v61 = [
        (v2 /*: any*/)
    ], v62 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVirtualEvent",
        "storageKey": null
    } as any, v63 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chargesEnabled",
        "storageKey": null
    } as any, v64 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payoutsEnabled",
        "storageKey": null
    } as any, v65 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileRef",
        "storageKey": null
    } as any, v66 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
    } as any, v67 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
    } as any, v68 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timezone",
        "storageKey": null
    } as any, v69 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startSeconds",
        "storageKey": null
    } as any, v70 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endSeconds",
        "storageKey": null
    } as any, v71 = {
        "alias": null,
        "args": null,
        "concreteType": "coach",
        "kind": "LinkedField",
        "name": "coach",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            (v17 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "user",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    (v66 /*: any*/),
                    (v67 /*: any*/),
                    (v68 /*: any*/),
                    (v2 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "coachUnavailableDate",
                "kind": "LinkedField",
                "name": "coachUnavailableDates",
                "plural": true,
                "selections": [
                    (v2 /*: any*/),
                    (v17 /*: any*/),
                    (v33 /*: any*/),
                    (v69 /*: any*/),
                    (v70 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAllDay",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "coachAvailability",
                "kind": "LinkedField",
                "name": "coachAvailabilities",
                "plural": true,
                "selections": [
                    (v17 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dayOfTheWeek",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAvailable",
                        "storageKey": null
                    },
                    (v69 /*: any*/),
                    (v70 /*: any*/),
                    (v2 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v72 = {
        "alias": null,
        "args": null,
        "concreteType": "stripeConnectAccount",
        "kind": "LinkedField",
        "name": "stripeConnectAccount",
        "plural": false,
        "selections": [
            (v64 /*: any*/),
            (v63 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    } as any, v73 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "coachCuid",
        "storageKey": null
    } as any, v74 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "canceledAt": (v10 /*: any*/)
            }
        } as any
    ], v75 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceOverride",
        "storageKey": null
    } as any, v76 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "registrationStatus",
        "storageKey": null
    } as any, v77 = {
        "alias": null,
        "args": [
            {
                "kind": "Literal",
                "name": "where",
                "value": (v25 /*: any*/)
            }
        ],
        "concreteType": "registration_aggregate",
        "kind": "LinkedField",
        "name": "registrations_aggregate",
        "plural": false,
        "selections": (v31 /*: any*/),
        "storageKey": "registrations_aggregate(where:{\"status\":{\"_eq\":\"complete\"}})"
    } as any, v78 = [
        (v68 /*: any*/),
        (v2 /*: any*/)
    ], v79 = {
        "alias": null,
        "args": null,
        "concreteType": "eventVenue",
        "kind": "LinkedField",
        "name": "eventVenues",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "venue",
                "kind": "LinkedField",
                "name": "venue",
                "plural": false,
                "selections": (v78 /*: any*/),
                "storageKey": null
            },
            (v2 /*: any*/)
        ],
        "storageKey": null
    } as any, v80 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "created_at",
        "storageKey": null
    } as any, v81 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "duration",
        "storageKey": null
    } as any, v82 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultPrice",
        "storageKey": null
    } as any, v83 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ageRange",
        "storageKey": null
    } as any, v84 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "genders",
        "storageKey": null
    } as any, v85 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizerCuid",
        "storageKey": null
    } as any, v86 = [
        (v46 /*: any*/)
    ], v87 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalInfo",
        "storageKey": null
    } as any, v88 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "category": (v11 /*: any*/)
            }
        } as any
    ], v89 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventCustomQuestionCuid",
        "storageKey": null
    } as any, v90 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "country",
        "storageKey": null
    } as any, v91 = [
        (v9 /*: any*/)
    ], v92 = {
        "alias": null,
        "args": null,
        "concreteType": "eventDiscipline",
        "kind": "LinkedField",
        "name": "eventDiscipline",
        "plural": false,
        "selections": [
            (v51 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    } as any, v93 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "info",
        "storageKey": null
    } as any, v94 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "seriesCuid",
        "storageKey": null
    } as any, v95 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "roundNumber",
        "storageKey": null
    } as any, v96 = {
        "alias": null,
        "args": null,
        "concreteType": "eventSeriesCategory",
        "kind": "LinkedField",
        "name": "eventSeriesCategories",
        "plural": true,
        "selections": [
            (v2 /*: any*/),
            (v17 /*: any*/),
            (v43 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventSeriesCuid",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v97 = {
        "alias": null,
        "args": null,
        "concreteType": "event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            (v17 /*: any*/),
            (v15 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "eventMetadata",
                "kind": "LinkedField",
                "name": "eventMetadata",
                "plural": false,
                "selections": [
                    (v16 /*: any*/),
                    (v5 /*: any*/),
                    (v2 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v98 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDefault",
        "storageKey": null
    } as any, v99 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bytes",
        "storageKey": null
    } as any, v100 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "format",
        "storageKey": null
    } as any, v101 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any, v102 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "originalFilename",
        "storageKey": null
    } as any, v103 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicId",
        "storageKey": null
    } as any, v104 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "relativeUrl",
        "storageKey": null
    } as any, v105 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resourceType",
        "storageKey": null
    } as any, v106 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any, v107 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
    } as any, v108 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any, v109 = {
        "alias": null,
        "args": null,
        "concreteType": "image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
            (v99 /*: any*/),
            (v100 /*: any*/),
            (v101 /*: any*/),
            (v102 /*: any*/),
            (v103 /*: any*/),
            (v104 /*: any*/),
            (v105 /*: any*/),
            (v106 /*: any*/),
            (v107 /*: any*/),
            (v108 /*: any*/),
            (v85 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    } as any, v110 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otherSanctionName",
        "storageKey": null
    } as any, v111 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oneDayFee",
        "storageKey": null
    } as any, v112 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasPermit",
        "storageKey": null
    } as any, v113 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "waiverLink",
        "storageKey": null
    } as any, v114 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isOneDayAvailable",
        "storageKey": null
    } as any, v115 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "website",
        "storageKey": null
    } as any, v116 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
    } as any, v117 = [
        (v2 /*: any*/),
        (v17 /*: any*/),
        (v16 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chipColor",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "className",
            "storageKey": null
        } as any,
        (v40 /*: any*/)
    ], v118 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventVolunteerJobCuid",
        "storageKey": null
    } as any, v119 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stock",
        "storageKey": null
    } as any, v120 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventPricingGroupCuid",
        "storageKey": null
    } as any, v121 = [
        (v2 /*: any*/),
        (v17 /*: any*/),
        (v16 /*: any*/),
        (v115 /*: any*/),
        {
            "alias": null,
            "args": null,
            "concreteType": "sponsorImage",
            "kind": "LinkedField",
            "name": "sponsorImages",
            "plural": true,
            "selections": [
                (v2 /*: any*/),
                (v17 /*: any*/),
                (v98 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "image",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v99 /*: any*/),
                        (v100 /*: any*/),
                        (v101 /*: any*/),
                        (v102 /*: any*/),
                        (v85 /*: any*/),
                        (v103 /*: any*/),
                        (v104 /*: any*/),
                        (v105 /*: any*/),
                        (v106 /*: any*/),
                        (v107 /*: any*/),
                        (v108 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ], v122 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ownerType",
        "storageKey": null
    } as any, v123 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fieldsConfiguration",
        "storageKey": null
    } as any, v124 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "revision",
        "storageKey": null
    } as any, v125 = {
        "alias": null,
        "args": null,
        "concreteType": "waiverRevision",
        "kind": "LinkedField",
        "name": "latestRevision",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            (v16 /*: any*/),
            (v65 /*: any*/),
            (v17 /*: any*/),
            (v123 /*: any*/),
            (v124 /*: any*/)
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "HostEventProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "eventConnection",
                    "kind": "LinkedField",
                    "name": "event_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "eventEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventMetadata",
                                            "kind": "LinkedField",
                                            "name": "eventMetadata",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "HostEventPage_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "HostEventMainView_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ValidityChecker_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "HeaderContainer_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "rulesDates_RuleEventEndAfterRegClose_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "rulesDates_RuleScheduleDatesInsideEventDate_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "rulesCategories_RuleAllCategoriesHaveCourse_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_useSyncSectionValidity_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_getUserTypeFromActivity_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_getEventActivity_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_getEventCuid_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_getEventSlug_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_getEventLink_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_useUpdateAlgoliaSearchIndexes_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_getEncodedEventId_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_getEncodedEventMetadataId_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_getIsEventPublished_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "helpers_getOrganizerCuid_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "hostEventMutations_useUnPublishEventMutation_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "EditEventNameDialog_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "OccurrencesDialog_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "OccurrenceInfo_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CustomQuestionsContainer_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "SaveCustomQuestionDialog_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "IntroSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "GeneralSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "generalSectionSideEffects_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "LocationContactSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "VirtualVenueContainer_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CourseSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ProgramSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AssessmentSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ChecklistSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "VibeSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "SeriesSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "SanctionSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "TicketsSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CategoryPresetContainer_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CategoriesSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CreateCategoryDialog_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "EditMultipleCategories_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "CoursesColumn_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "categoriesSectionSideEffects_scheduleItemOnCategoryDelete_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "categoriesSectionSideEffects_customQuestionOnCategoryDelete_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "categoriesSectionSideEffects_eventSanctionOnCategoryDelete_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "categoriesSectionSideEffects_eventSeriesOnCategoryDelete_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "categoriesSectionSideEffects_eventBasicWaiverOnCategoryDelete_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "DisciplineTabContainer_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "DisciplineTable_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "VolunteersSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "MerchandiseSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "RegistrationSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "EventCapacityContainer_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "PromoCodesContainer_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "PricingSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleTypePicker_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ImagesSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AmenitiesSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AwardsSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "SponsorsSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "AdditionalInfoSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "WaiverSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "BasicWaiverSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleClinicSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleClinicDialog_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleRideSection_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleRideDialog_event"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "FinishSection_event"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v7 /*: any*/),
                    "concreteType": "sanctionConnection",
                    "kind": "LinkedField",
                    "name": "sanction_connection",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SanctionSection_sanctions"
                        }
                    ],
                    "storageKey": "sanction_connection(order_by:{\"id\":\"asc\"})"
                },
                {
                    "alias": null,
                    "args": (v12 /*: any*/),
                    "concreteType": "sponsorConnection",
                    "kind": "LinkedField",
                    "name": "sponsor_connection",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SponsorTierItem_sponsors"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v13 /*: any*/),
                    "concreteType": "scheduleTypePresetConnection",
                    "kind": "LinkedField",
                    "name": "scheduleTypePreset_connection",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SaveScheduleItemDialog_scheduleTypePreset"
                        }
                    ],
                    "storageKey": "scheduleTypePreset_connection(order_by:[{\"activity\":\"desc\"},{\"id\":\"asc\"}])"
                },
                {
                    "alias": null,
                    "args": (v7 /*: any*/),
                    "concreteType": "amenityConnection",
                    "kind": "LinkedField",
                    "name": "amenity_connection",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AmenitiesSection_amenities"
                        }
                    ],
                    "storageKey": "amenity_connection(order_by:{\"id\":\"asc\"})"
                },
                {
                    "alias": "globalPresetWaivers",
                    "args": (v14 /*: any*/),
                    "concreteType": "waiverConnection",
                    "kind": "LinkedField",
                    "name": "waiver_connection",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "WaiverSection_waiverConnection"
                        }
                    ],
                    "storageKey": "waiver_connection(where:{\"_and\":{\"deleted_at\":{\"_is_null\":true},\"ownerType\":{\"_eq\":\"REGGY\"}}})"
                }
            ],
            "type": "query_root",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "HostEventProviderQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "eventConnection",
                    "kind": "LinkedField",
                    "name": "event_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "eventEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v15 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventMetadata",
                                            "kind": "LinkedField",
                                            "name": "eventMetadata",
                                            "plural": false,
                                            "selections": [
                                                (v16 /*: any*/),
                                                (v2 /*: any*/),
                                                (v5 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v19 /*: any*/),
                                                    "concreteType": "event",
                                                    "kind": "LinkedField",
                                                    "name": "events",
                                                    "plural": true,
                                                    "selections": [
                                                        (v17 /*: any*/),
                                                        (v2 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v3 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v27 /*: any*/)
                                                    ],
                                                    "storageKey": "events(where:{\"deleted_at\":{\"_is_null\":true}})"
                                                },
                                                (v28 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "organizer",
                                                    "kind": "LinkedField",
                                                    "name": "organizer",
                                                    "plural": false,
                                                    "selections": [
                                                        (v28 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v29 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v21 /*: any*/),
                                        (v4 /*: any*/),
                                        (v23 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "_and": [
                                                            (v26 /*: any*/)
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "registration_aggregate",
                                            "kind": "LinkedField",
                                            "name": "registrations_aggregate",
                                            "plural": false,
                                            "selections": (v31 /*: any*/),
                                            "storageKey": "registrations_aggregate(where:{\"_and\":[{\"_or\":[{\"status\":{\"_eq\":\"complete\"}},{\"status\":{\"_eq\":\"canceled\"}}]}]})"
                                        },
                                        (v20 /*: any*/),
                                        (v22 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isEventCreationComplete",
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/),
                                        (v17 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "regCloseDate",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v32 /*: any*/),
                                            "concreteType": "eventScheduleDate",
                                            "kind": "LinkedField",
                                            "name": "eventScheduleDates",
                                            "plural": true,
                                            "selections": [
                                                (v17 /*: any*/),
                                                (v33 /*: any*/),
                                                (v34 /*: any*/),
                                                (v2 /*: any*/),
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventSchedule",
                                                    "kind": "LinkedField",
                                                    "name": "eventSchedules",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v36 /*: any*/),
                                                        (v37 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "endTime",
                                                            "storageKey": null
                                                        },
                                                        (v35 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "addedInternally",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "eventScheduleDateCuid",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventScheduleTypePreset",
                                                            "kind": "LinkedField",
                                                            "name": "eventScheduleTypePreset",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v38 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "scheduleTypePresetCuid",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "scheduleTypePreset",
                                                                    "kind": "LinkedField",
                                                                    "name": "scheduleTypePreset",
                                                                    "plural": false,
                                                                    "selections": (v41 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v42 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventScheduleCategory",
                                                            "kind": "LinkedField",
                                                            "name": "eventScheduleCategories",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v43 /*: any*/),
                                                                (v44 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v45 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventScheduleTypeCustom",
                                                            "kind": "LinkedField",
                                                            "name": "eventScheduleTypeCustom",
                                                            "plural": false,
                                                            "selections": (v41 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventScheduleDates(order_by:{\"date\":\"asc\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v47 /*: any*/),
                                            "concreteType": "category",
                                            "kind": "LinkedField",
                                            "name": "categories",
                                            "plural": true,
                                            "selections": [
                                                (v17 /*: any*/),
                                                (v16 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "categoryCourse",
                                                    "kind": "LinkedField",
                                                    "name": "categoryCourses",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v48 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "category",
                                                            "kind": "LinkedField",
                                                            "name": "category",
                                                            "plural": false,
                                                            "selections": (v49 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        (v43 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/),
                                                (v50 /*: any*/),
                                                (v52 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "additionalPrizes",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "ageAsOf",
                                                    "storageKey": null
                                                },
                                                (v45 /*: any*/),
                                                (v53 /*: any*/),
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "gender",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "maxAge",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "minAge",
                                                    "storageKey": null
                                                },
                                                (v54 /*: any*/),
                                                (v55 /*: any*/),
                                                (v56 /*: any*/),
                                                (v57 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventScheduleCategory",
                                                    "kind": "LinkedField",
                                                    "name": "eventScheduleCategories",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v44 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v60 /*: any*/),
                                                    "concreteType": "registrationCategory",
                                                    "kind": "LinkedField",
                                                    "name": "registrationCategories",
                                                    "plural": true,
                                                    "selections": (v61 /*: any*/),
                                                    "storageKey": "registrationCategories(limit:1,where:{\"registration\":{\"status\":{\"_eq\":\"complete\"}}})"
                                                }
                                            ],
                                            "storageKey": "categories(order_by:{\"position\":\"asc\"},where:{\"deleted_at\":{\"_is_null\":true}})"
                                        },
                                        (v62 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "currencyCode",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "completedSections",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "organizer",
                                            "kind": "LinkedField",
                                            "name": "organizer",
                                            "plural": false,
                                            "selections": [
                                                (v17 /*: any*/),
                                                (v2 /*: any*/),
                                                (v28 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "stripeConnectAccount",
                                                    "kind": "LinkedField",
                                                    "name": "stripeConnectAccount",
                                                    "plural": false,
                                                    "selections": [
                                                        (v63 /*: any*/),
                                                        (v64 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v19 /*: any*/),
                                                    "concreteType": "event",
                                                    "kind": "LinkedField",
                                                    "name": "events",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "distinct_on",
                                                                    "value": [
                                                                        "name"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "eventBasicWaiver",
                                                            "kind": "LinkedField",
                                                            "name": "eventBasicWaivers",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v65 /*: any*/),
                                                                (v17 /*: any*/)
                                                            ],
                                                            "storageKey": "eventBasicWaivers(distinct_on:[\"name\"])"
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": "events(where:{\"deleted_at\":{\"_is_null\":true}})"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "userOrganizerRole",
                                                    "kind": "LinkedField",
                                                    "name": "userOrganizerRoles",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "user",
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v71 /*: any*/),
                                                                (v66 /*: any*/),
                                                                (v67 /*: any*/),
                                                                (v68 /*: any*/),
                                                                (v28 /*: any*/),
                                                                (v72 /*: any*/),
                                                                (v73 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v74 /*: any*/),
                                            "concreteType": "ride",
                                            "kind": "LinkedField",
                                            "name": "rides",
                                            "plural": true,
                                            "selections": [
                                                (v75 /*: any*/),
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v35 /*: any*/),
                                                (v23 /*: any*/),
                                                (v24 /*: any*/),
                                                (v56 /*: any*/),
                                                (v76 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "dayOfContact",
                                                    "storageKey": null
                                                },
                                                (v77 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "event",
                                                    "kind": "LinkedField",
                                                    "name": "event",
                                                    "plural": false,
                                                    "selections": [
                                                        (v15 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "eventMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                (v16 /*: any*/),
                                                                (v29 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v79 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "rideDay",
                                                    "kind": "LinkedField",
                                                    "name": "rideDays",
                                                    "plural": true,
                                                    "selections": [
                                                        (v17 /*: any*/),
                                                        (v37 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v80 /*: any*/)
                                            ],
                                            "storageKey": "rides(where:{\"canceledAt\":{\"_is_null\":true}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v74 /*: any*/),
                                            "concreteType": "clinic",
                                            "kind": "LinkedField",
                                            "name": "clinics",
                                            "plural": true,
                                            "selections": [
                                                (v75 /*: any*/),
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "clinicDay",
                                                    "kind": "LinkedField",
                                                    "name": "clinicDays",
                                                    "plural": true,
                                                    "selections": [
                                                        (v37 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventClinicDayDuration",
                                                            "kind": "LinkedField",
                                                            "name": "eventClinicDayDuration",
                                                            "plural": false,
                                                            "selections": [
                                                                (v81 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v34 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "eventClinicDayDurationCuid",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v35 /*: any*/),
                                                (v23 /*: any*/),
                                                (v24 /*: any*/),
                                                (v56 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "meetingLink",
                                                    "storageKey": null
                                                },
                                                (v76 /*: any*/),
                                                (v77 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "event",
                                                    "kind": "LinkedField",
                                                    "name": "event",
                                                    "plural": false,
                                                    "selections": [
                                                        (v62 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventVirtualVenue",
                                                            "kind": "LinkedField",
                                                            "name": "eventVirtualVenues",
                                                            "plural": true,
                                                            "selections": (v78 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        (v79 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventProgram",
                                                            "kind": "LinkedField",
                                                            "name": "eventPrograms",
                                                            "plural": true,
                                                            "selections": [
                                                                (v82 /*: any*/),
                                                                (v83 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventClinicDayDuration",
                                                            "kind": "LinkedField",
                                                            "name": "eventClinicDayDurations",
                                                            "plural": true,
                                                            "selections": [
                                                                (v17 /*: any*/),
                                                                (v34 /*: any*/),
                                                                (v81 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "organizer",
                                                            "kind": "LinkedField",
                                                            "name": "organizer",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "userOrganizerRole",
                                                                    "kind": "LinkedField",
                                                                    "name": "userOrganizerRoles",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "user",
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v66 /*: any*/),
                                                                                (v67 /*: any*/),
                                                                                (v68 /*: any*/),
                                                                                (v28 /*: any*/),
                                                                                (v73 /*: any*/),
                                                                                (v72 /*: any*/),
                                                                                (v71 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "clinicCoach",
                                                    "kind": "LinkedField",
                                                    "name": "clinicCoaches",
                                                    "plural": true,
                                                    "selections": [
                                                        (v17 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "clinicCuid",
                                                            "storageKey": null
                                                        },
                                                        (v73 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "clinics(where:{\"canceledAt\":{\"_is_null\":true}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventProgram",
                                            "kind": "LinkedField",
                                            "name": "eventPrograms",
                                            "plural": true,
                                            "selections": [
                                                (v82 /*: any*/),
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "overview",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "skills",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "focus",
                                                    "storageKey": null
                                                },
                                                (v84 /*: any*/),
                                                (v83 /*: any*/),
                                                (v55 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v85 /*: any*/),
                                        (v27 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": (v86 /*: any*/),
                                            "concreteType": "eventCustomQuestion",
                                            "kind": "LinkedField",
                                            "name": "eventCustomQuestions",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "internalPurpose",
                                                    "storageKey": null
                                                },
                                                (v87 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isRequired",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "questionType",
                                                    "storageKey": null
                                                },
                                                (v36 /*: any*/),
                                                (v54 /*: any*/),
                                                (v42 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v88 /*: any*/),
                                                    "concreteType": "eventCustomQuestionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "eventCustomQuestionCategories",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v43 /*: any*/),
                                                        (v89 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "category",
                                                            "kind": "LinkedField",
                                                            "name": "category",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v16 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "eventCustomQuestionCategories(where:{\"category\":{\"deleted_at\":{\"_is_null\":true}}})"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v86 /*: any*/),
                                                    "concreteType": "eventCustomQuestionOption",
                                                    "kind": "LinkedField",
                                                    "name": "eventCustomQuestionOptions",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v54 /*: any*/),
                                                        (v89 /*: any*/)
                                                    ],
                                                    "storageKey": "eventCustomQuestionOptions(order_by:{\"position\":\"asc\"})"
                                                }
                                            ],
                                            "storageKey": "eventCustomQuestions(order_by:{\"position\":\"asc\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "eventAccess",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventVirtualVenue",
                                            "kind": "LinkedField",
                                            "name": "eventVirtualVenues",
                                            "plural": true,
                                            "selections": [
                                                (v68 /*: any*/),
                                                (v2 /*: any*/),
                                                (v17 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventVenue",
                                            "kind": "LinkedField",
                                            "name": "eventVenues",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "venue",
                                                    "kind": "LinkedField",
                                                    "name": "venue",
                                                    "plural": false,
                                                    "selections": [
                                                        (v68 /*: any*/),
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v16 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "placeId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "lat",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "lng",
                                                            "storageKey": null
                                                        },
                                                        (v85 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "fullAddress",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "addressWithName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "address",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "city",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "state",
                                                            "storageKey": null
                                                        },
                                                        (v90 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "countryCode",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "postalCode",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "meetupInstructions",
                                                    "storageKey": null
                                                },
                                                (v87 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "campingDescription",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "parkingInfo",
                                                    "storageKey": null
                                                },
                                                (v17 /*: any*/),
                                                (v35 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventClinicDayDuration",
                                            "kind": "LinkedField",
                                            "name": "eventClinicDayDurations",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v34 /*: any*/),
                                                (v81 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v91 /*: any*/),
                                            "concreteType": "eventDiscipline",
                                            "kind": "LinkedField",
                                            "name": "eventDisciplines",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v51 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v47 /*: any*/),
                                                    "concreteType": "category",
                                                    "kind": "LinkedField",
                                                    "name": "categories",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v92 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                (v58 /*: any*/)
                                                            ],
                                                            "concreteType": "registrationCategory",
                                                            "kind": "LinkedField",
                                                            "name": "registrationCategories",
                                                            "plural": true,
                                                            "selections": (v61 /*: any*/),
                                                            "storageKey": "registrationCategories(limit:1)"
                                                        }
                                                    ],
                                                    "storageKey": "categories(order_by:{\"position\":\"asc\"},where:{\"deleted_at\":{\"_is_null\":true}})"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "course",
                                                    "kind": "LinkedField",
                                                    "name": "courses",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v92 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "fieldLimit",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventDisciplines(order_by:{\"created_at\":\"asc\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "additionalContactInfo",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "email",
                                            "storageKey": null
                                        },
                                        (v16 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "phone",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isCourseEvent",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v91 /*: any*/),
                                            "concreteType": "course",
                                            "kind": "LinkedField",
                                            "name": "courses",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "platform",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "platformId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "platformUrl",
                                                    "storageKey": null
                                                },
                                                (v17 /*: any*/),
                                                (v16 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "fullName",
                                                    "storageKey": null
                                                },
                                                (v45 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "difficultyName",
                                                    "storageKey": null
                                                },
                                                (v53 /*: any*/),
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "courseLength",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "courseLengthType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "courseLengthSecondary",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "courseLengthTypeSecondary",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "totalElevationGain",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "totalElevationLoss",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "elevationUnit",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v88 /*: any*/),
                                                    "concreteType": "categoryCourse",
                                                    "kind": "LinkedField",
                                                    "name": "categoryCourses",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "category",
                                                            "kind": "LinkedField",
                                                            "name": "category",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": [
                                                                        (v59 /*: any*/)
                                                                    ],
                                                                    "concreteType": "registrationCategory_aggregate",
                                                                    "kind": "LinkedField",
                                                                    "name": "registrationCategories_aggregate",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "registrationCategory_aggregate_fields",
                                                                            "kind": "LinkedField",
                                                                            "name": "aggregate",
                                                                            "plural": false,
                                                                            "selections": (v30 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": "registrationCategories_aggregate(where:{\"registration\":{\"status\":{\"_eq\":\"complete\"}}})"
                                                                },
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v48 /*: any*/),
                                                        (v43 /*: any*/)
                                                    ],
                                                    "storageKey": "categoryCourses(where:{\"category\":{\"deleted_at\":{\"_is_null\":true}}})"
                                                },
                                                (v52 /*: any*/)
                                            ],
                                            "storageKey": "courses(order_by:{\"created_at\":\"asc\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventChecklistItem",
                                            "kind": "LinkedField",
                                            "name": "eventChecklistItems",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v16 /*: any*/),
                                                (v93 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventVibe",
                                            "kind": "LinkedField",
                                            "name": "eventVibes",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "ridingTimePerDayRange",
                                                    "storageKey": null
                                                },
                                                (v55 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "hasAverageSpeed",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "averageSpeedRange",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "intensityRange",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "moreInfo",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "rideType",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "speedType",
                                                    "storageKey": null
                                                },
                                                (v84 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isSeriesEvent",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v19 /*: any*/),
                                            "concreteType": "eventSeries",
                                            "kind": "LinkedField",
                                            "name": "eventSeries",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v35 /*: any*/),
                                                (v94 /*: any*/),
                                                (v95 /*: any*/),
                                                (v42 /*: any*/),
                                                (v96 /*: any*/),
                                                (v97 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "series",
                                                    "kind": "LinkedField",
                                                    "name": "series",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v45 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "seriesActivity",
                                                            "storageKey": null
                                                        },
                                                        (v85 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "totalRounds",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isJoinable",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "joinKey",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v19 /*: any*/),
                                                            "concreteType": "eventSeries",
                                                            "kind": "LinkedField",
                                                            "name": "eventSeries",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v35 /*: any*/),
                                                                (v94 /*: any*/),
                                                                (v95 /*: any*/),
                                                                (v42 /*: any*/),
                                                                (v97 /*: any*/),
                                                                (v96 /*: any*/)
                                                            ],
                                                            "storageKey": "eventSeries(where:{\"deleted_at\":{\"_is_null\":true}})"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "seriesImage",
                                                            "kind": "LinkedField",
                                                            "name": "seriesImages",
                                                            "plural": true,
                                                            "selections": [
                                                                (v98 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v109 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "seriesPointsStructureCustom",
                                                            "kind": "LinkedField",
                                                            "name": "seriesPointsStructureCustoms",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v38 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "isQualifying",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "points",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "pointsName",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "seriesPointsStructurePreset",
                                                            "kind": "LinkedField",
                                                            "name": "seriesPointsStructurePresets",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "presetCuid",
                                                                    "storageKey": null
                                                                },
                                                                (v38 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventSeries(where:{\"deleted_at\":{\"_is_null\":true}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isSanctionedEvent",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventSanction",
                                            "kind": "LinkedField",
                                            "name": "eventSanctions",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v35 /*: any*/),
                                                (v110 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "permit",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "sanctionCuid",
                                                    "storageKey": null
                                                },
                                                (v42 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "allowOneDayLicense",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isLicenseRequired",
                                                    "storageKey": null
                                                },
                                                (v111 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventSanctionCategory",
                                                    "kind": "LinkedField",
                                                    "name": "eventSanctionCategories",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v43 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "eventSanctionCuid",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "sanction",
                                                    "kind": "LinkedField",
                                                    "name": "sanction",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v112 /*: any*/),
                                                        (v113 /*: any*/),
                                                        (v114 /*: any*/),
                                                        (v90 /*: any*/),
                                                        (v115 /*: any*/),
                                                        (v111 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isTicketedEvent",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v19 /*: any*/),
                                            "concreteType": "eventTicket",
                                            "kind": "LinkedField",
                                            "name": "eventTickets",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v16 /*: any*/),
                                                (v45 /*: any*/),
                                                (v116 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "ticketsAvailable",
                                                    "storageKey": null
                                                },
                                                (v57 /*: any*/),
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": (v60 /*: any*/),
                                                    "concreteType": "registrationTicket",
                                                    "kind": "LinkedField",
                                                    "name": "registrationTickets",
                                                    "plural": true,
                                                    "selections": (v61 /*: any*/),
                                                    "storageKey": "registrationTickets(limit:1,where:{\"registration\":{\"status\":{\"_eq\":\"complete\"}}})"
                                                }
                                            ],
                                            "storageKey": "eventTickets(where:{\"deleted_at\":{\"_is_null\":true}})"
                                        },
                                        (v80 /*: any*/),
                                        (v28 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": (v91 /*: any*/),
                                            "concreteType": "eventBasicWaiver",
                                            "kind": "LinkedField",
                                            "name": "eventBasicWaivers",
                                            "plural": true,
                                            "selections": [
                                                (v17 /*: any*/),
                                                (v16 /*: any*/),
                                                (v65 /*: any*/),
                                                (v35 /*: any*/),
                                                (v42 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventBasicWaiverCategory",
                                                    "kind": "LinkedField",
                                                    "name": "eventBasicWaiverCategories",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v43 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "eventBasicWaiverCuid",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": "eventBasicWaivers(order_by:{\"created_at\":\"asc\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasVolunteers",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "order_by",
                                                    "value": [
                                                        {
                                                            "title": "asc"
                                                        },
                                                        (v8 /*: any*/)
                                                    ]
                                                },
                                                (v18 /*: any*/)
                                            ],
                                            "concreteType": "eventVolunteerJob",
                                            "kind": "LinkedField",
                                            "name": "eventVolunteerJobs",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v36 /*: any*/),
                                                (v45 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "locationInfo",
                                                    "storageKey": null
                                                },
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventVolunteerJobTask",
                                                    "kind": "LinkedField",
                                                    "name": "eventVolunteerJobTasks",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "volunteerTaskPriorityCuid",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "volunteerTaskPriorities",
                                                            "kind": "LinkedField",
                                                            "name": "volunteerTaskPriority",
                                                            "plural": false,
                                                            "selections": (v117 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "volunteerTaskDifficultyCuid",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "volunteerTaskDifficulties",
                                                            "kind": "LinkedField",
                                                            "name": "volunteerTaskDifficulty",
                                                            "plural": false,
                                                            "selections": (v117 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        (v45 /*: any*/),
                                                        (v118 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventVolunteerJobShift",
                                                    "kind": "LinkedField",
                                                    "name": "eventVolunteerJobShifts",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v118 /*: any*/),
                                                        (v56 /*: any*/),
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "eventVolunteerJobShiftTask",
                                                            "kind": "LinkedField",
                                                            "name": "eventVolunteerJobShiftTasks",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "eventVolunteerJobShiftCuid",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "eventVolunteerJobTaskCuid",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventVolunteerJobs(order_by:[{\"title\":\"asc\"},{\"created_at\":\"asc\"}],where:{\"deleted_at\":{\"_is_null\":true}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasMerchandise",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "merchandise": (v11 /*: any*/)
                                                    }
                                                }
                                            ],
                                            "concreteType": "eventMerchandise",
                                            "kind": "LinkedField",
                                            "name": "eventMerchandises",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v57 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "availableTo",
                                                    "storageKey": null
                                                },
                                                (v17 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "merchandise",
                                                    "kind": "LinkedField",
                                                    "name": "merchandise",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v36 /*: any*/),
                                                        (v45 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "deliveryType",
                                                            "storageKey": null
                                                        },
                                                        (v116 /*: any*/),
                                                        (v119 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "merchandiseImage",
                                                            "kind": "LinkedField",
                                                            "name": "merchandiseImages",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v98 /*: any*/),
                                                                (v109 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "merchandiseVariantOption",
                                                            "kind": "LinkedField",
                                                            "name": "merchandiseVariantOptions",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "optionName",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "merchandiseVariantOptionValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "merchandiseVariantOptionValues",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "value",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "merchandiseVariantOptionCuid",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "merchandiseVariant",
                                                            "kind": "LinkedField",
                                                            "name": "merchandiseVariants",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "merchandiseCuid",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "optionCuidValueCuid",
                                                                    "storageKey": null
                                                                },
                                                                (v119 /*: any*/),
                                                                (v116 /*: any*/),
                                                                (v109 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventMerchandises(where:{\"merchandise\":{\"deleted_at\":{\"_is_null\":true}}})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "regOpenDate",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "selfEditEndDate",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isRegistrationPaused",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "nonCategoriedRegDeadline",
                                            "storageKey": null
                                        },
                                        (v56 /*: any*/),
                                        {
                                            "alias": "completeAndInProgressRegistrations",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "_and": [
                                                            {
                                                                "status": {
                                                                    "_in": [
                                                                        "complete",
                                                                        "in_progress"
                                                                    ]
                                                                }
                                                            },
                                                            {
                                                                "_not": {
                                                                    "registrationCategories": {
                                                                        "categoryCuid": (v10 /*: any*/)
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            ],
                                            "concreteType": "registration_aggregate",
                                            "kind": "LinkedField",
                                            "name": "registrations_aggregate",
                                            "plural": false,
                                            "selections": (v31 /*: any*/),
                                            "storageKey": "registrations_aggregate(where:{\"_and\":[{\"status\":{\"_in\":[\"complete\",\"in_progress\"]}},{\"_not\":{\"registrationCategories\":{\"categoryCuid\":{\"_is_null\":true}}}}]})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventPromoCode",
                                            "kind": "LinkedField",
                                            "name": "eventPromoCodes",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "amountOff",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "percentOff",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "code",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "codesAvailable",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "validFrom",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "validTo",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isInactive",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasDynamicPricing",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v32 /*: any*/),
                                            "concreteType": "eventPricingDate",
                                            "kind": "LinkedField",
                                            "name": "eventPricingDates",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v33 /*: any*/),
                                                (v35 /*: any*/)
                                            ],
                                            "storageKey": "eventPricingDates(order_by:{\"date\":\"asc\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventPricingChange",
                                            "kind": "LinkedField",
                                            "name": "eventPricingChanges",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "amount",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "eventPricingDateCuid",
                                                    "storageKey": null
                                                },
                                                (v120 /*: any*/),
                                                (v35 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventPricingGroup",
                                            "kind": "LinkedField",
                                            "name": "eventPricingGroups",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v16 /*: any*/),
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventPricingGroupCategory",
                                                    "kind": "LinkedField",
                                                    "name": "eventPricingGroupCategories",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v120 /*: any*/),
                                                        (v43 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "category",
                                                            "kind": "LinkedField",
                                                            "name": "category",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v50 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventScheduleTypeCustom",
                                            "kind": "LinkedField",
                                            "name": "eventScheduleTypeCustoms",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v39 /*: any*/),
                                                (v40 /*: any*/),
                                                (v38 /*: any*/),
                                                (v35 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v86 /*: any*/),
                                            "concreteType": "eventImage",
                                            "kind": "LinkedField",
                                            "name": "eventImages",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v54 /*: any*/),
                                                (v35 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "imagePublicId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "image",
                                                    "kind": "LinkedField",
                                                    "name": "image",
                                                    "plural": false,
                                                    "selections": [
                                                        (v99 /*: any*/),
                                                        (v100 /*: any*/),
                                                        (v101 /*: any*/),
                                                        (v102 /*: any*/),
                                                        (v85 /*: any*/),
                                                        (v103 /*: any*/),
                                                        (v104 /*: any*/),
                                                        (v105 /*: any*/),
                                                        (v106 /*: any*/),
                                                        (v107 /*: any*/),
                                                        (v108 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventImages(order_by:{\"position\":\"asc\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventAmenity",
                                            "kind": "LinkedField",
                                            "name": "eventAmenities",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "amenityCuid",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isSponsoredEvent",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v86 /*: any*/),
                                            "concreteType": "eventSponsor",
                                            "kind": "LinkedField",
                                            "name": "eventSponsors",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "tierName",
                                                    "storageKey": null
                                                },
                                                (v54 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "sponsor",
                                                    "kind": "LinkedField",
                                                    "name": "sponsor",
                                                    "plural": false,
                                                    "selections": (v121 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "eventSponsors(order_by:{\"position\":\"asc\"})"
                                        },
                                        (v45 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "eventWebsite",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "refundInfo",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "eventAdditionalInfo",
                                            "kind": "LinkedField",
                                            "name": "eventAdditionalInfos",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                (v36 /*: any*/),
                                                (v45 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasGeneralWaivers",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "where",
                                                    "value": {
                                                        "type": {
                                                            "_eq": "GENERAL"
                                                        },
                                                        "waiver": (v11 /*: any*/)
                                                    }
                                                }
                                            ],
                                            "concreteType": "eventWaiver",
                                            "kind": "LinkedField",
                                            "name": "eventWaivers",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "waiver",
                                                    "kind": "LinkedField",
                                                    "name": "waiver",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v122 /*: any*/),
                                                        (v125 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": "eventWaivers(where:{\"type\":{\"_eq\":\"GENERAL\"},\"waiver\":{\"deleted_at\":{\"_is_null\":true}}})"
                                        },
                                        {
                                            "alias": "sanctions",
                                            "args": null,
                                            "concreteType": "eventSanction",
                                            "kind": "LinkedField",
                                            "name": "eventSanctions",
                                            "plural": true,
                                            "selections": [
                                                (v17 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "sanction",
                                                    "kind": "LinkedField",
                                                    "name": "sanction",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v16 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v110 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "eventWaiver",
                                                    "kind": "LinkedField",
                                                    "name": "eventWaivers",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "waiver",
                                                            "kind": "LinkedField",
                                                            "name": "waiver",
                                                            "plural": false,
                                                            "selections": [
                                                                (v17 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v122 /*: any*/),
                                                                (v125 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v7 /*: any*/),
                    "concreteType": "sanctionConnection",
                    "kind": "LinkedField",
                    "name": "sanction_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "sanctionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "sanction",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v17 /*: any*/),
                                        (v16 /*: any*/),
                                        (v112 /*: any*/),
                                        (v90 /*: any*/),
                                        (v114 /*: any*/),
                                        (v111 /*: any*/),
                                        (v113 /*: any*/),
                                        (v115 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "sanction_connection(order_by:{\"id\":\"asc\"})"
                },
                {
                    "alias": null,
                    "args": (v12 /*: any*/),
                    "concreteType": "sponsorConnection",
                    "kind": "LinkedField",
                    "name": "sponsor_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "sponsorEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "sponsor",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v121 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v13 /*: any*/),
                    "concreteType": "scheduleTypePresetConnection",
                    "kind": "LinkedField",
                    "name": "scheduleTypePreset_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "scheduleTypePresetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "scheduleTypePreset",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v17 /*: any*/),
                                        (v39 /*: any*/),
                                        (v4 /*: any*/),
                                        (v40 /*: any*/),
                                        (v38 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "scheduleTypePreset_connection(order_by:[{\"activity\":\"desc\"},{\"id\":\"asc\"}])"
                },
                {
                    "alias": null,
                    "args": (v7 /*: any*/),
                    "concreteType": "amenityConnection",
                    "kind": "LinkedField",
                    "name": "amenity_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "amenityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "amenity",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v17 /*: any*/),
                                        (v16 /*: any*/),
                                        (v93 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "imageUrl",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "amenity_connection(order_by:{\"id\":\"asc\"})"
                },
                {
                    "alias": "globalPresetWaivers",
                    "args": (v14 /*: any*/),
                    "concreteType": "waiverConnection",
                    "kind": "LinkedField",
                    "name": "waiver_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "waiverEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "waiver",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v17 /*: any*/),
                                        (v122 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "sanctionWaivers",
                                            "kind": "LinkedField",
                                            "name": "sanctionWaivers",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "sanction",
                                                    "kind": "LinkedField",
                                                    "name": "sanction",
                                                    "plural": false,
                                                    "selections": (v49 /*: any*/),
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "waiverRevision",
                                            "kind": "LinkedField",
                                            "name": "latestRevision",
                                            "plural": false,
                                            "selections": [
                                                (v17 /*: any*/),
                                                (v123 /*: any*/),
                                                (v65 /*: any*/),
                                                (v2 /*: any*/),
                                                (v16 /*: any*/),
                                                (v124 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "waiver_connection(where:{\"_and\":{\"deleted_at\":{\"_is_null\":true},\"ownerType\":{\"_eq\":\"REGGY\"}}})"
                }
            ]
        },
        "params": {
            "cacheID": "145add6116945ee11c4d6b6294202f7c",
            "id": null,
            "metadata": {},
            "name": "HostEventProviderQuery",
            "operationKind": "query",
            "text": "query HostEventProviderQuery(\n  $cuid: String!\n  $organizerSlug: String!\n) {\n  event_connection(where: {cuid: {_eq: $cuid}}) {\n    edges {\n      node {\n        ...HostEventPage_event\n        ...HostEventMainView_event\n        ...ValidityChecker_event\n        ...HeaderContainer_event\n        ...rulesDates_RuleEventEndAfterRegClose_event\n        ...rulesDates_RuleScheduleDatesInsideEventDate_event\n        ...rulesCategories_RuleAllCategoriesHaveCourse_event\n        ...helpers_useSyncSectionValidity_event\n        ...helpers_getUserTypeFromActivity_event\n        ...helpers_getEventActivity_event\n        ...helpers_getEventCuid_event\n        ...helpers_getEventSlug_event\n        ...helpers_getEventLink_event\n        ...helpers_useUpdateAlgoliaSearchIndexes_event\n        ...helpers_getEncodedEventId_event\n        ...helpers_getEncodedEventMetadataId_event\n        ...helpers_getIsEventPublished_event\n        ...helpers_getOrganizerCuid_event\n        ...hostEventMutations_useUnPublishEventMutation_event\n        ...EditEventNameDialog_event\n        ...OccurrencesDialog_event\n        ...OccurrenceInfo_event\n        ...CustomQuestionsContainer_event\n        ...SaveCustomQuestionDialog_event\n        ...IntroSection_event\n        ...GeneralSection_event\n        ...generalSectionSideEffects_event\n        ...LocationContactSection_event\n        ...VirtualVenueContainer_event\n        ...CourseSection_event\n        ...ProgramSection_event\n        ...AssessmentSection_event\n        ...ChecklistSection_event\n        ...VibeSection_event\n        ...SeriesSection_event\n        ...SanctionSection_event\n        ...TicketsSection_event\n        ...CategoryPresetContainer_event\n        ...CategoriesSection_event\n        ...CreateCategoryDialog_event\n        ...EditMultipleCategories_event\n        ...CoursesColumn_event\n        ...categoriesSectionSideEffects_scheduleItemOnCategoryDelete_event\n        ...categoriesSectionSideEffects_customQuestionOnCategoryDelete_event\n        ...categoriesSectionSideEffects_eventSanctionOnCategoryDelete_event\n        ...categoriesSectionSideEffects_eventSeriesOnCategoryDelete_event\n        ...categoriesSectionSideEffects_eventBasicWaiverOnCategoryDelete_event\n        ...DisciplineTabContainer_event\n        ...DisciplineTable_event\n        ...VolunteersSection_event\n        ...MerchandiseSection_event\n        ...RegistrationSection_event\n        ...EventCapacityContainer_event\n        ...PromoCodesContainer_event\n        ...PricingSection_event\n        ...ScheduleSection_event\n        ...ScheduleTypePicker_event\n        ...ImagesSection_event\n        ...AmenitiesSection_event\n        ...AwardsSection_event\n        ...SponsorsSection_event\n        ...AdditionalInfoSection_event\n        ...WaiverSection_event\n        ...BasicWaiverSection_event\n        ...ScheduleClinicSection_event\n        ...ScheduleClinicDialog_event\n        ...ScheduleRideSection_event\n        ...ScheduleRideDialog_event\n        ...FinishSection_event\n        id\n        publishedAt\n        activity\n        eventMetadata {\n          isCategoriedEvent\n          id\n        }\n      }\n    }\n  }\n  sanction_connection(order_by: {id: asc}) {\n    ...SanctionSection_sanctions\n  }\n  sponsor_connection(order_by: {created_at: asc}, where: {_and: [{deleted_at: {_is_null: true}}, {organizer: {slug: {_eq: $organizerSlug}}}]}) {\n    ...SponsorTierItem_sponsors\n  }\n  scheduleTypePreset_connection(order_by: [{activity: desc}, {id: asc}]) {\n    ...SaveScheduleItemDialog_scheduleTypePreset\n  }\n  amenity_connection(order_by: {id: asc}) {\n    ...AmenitiesSection_amenities\n  }\n  globalPresetWaivers: waiver_connection(where: {_and: {deleted_at: {_is_null: true}, ownerType: {_eq: REGGY}}}) {\n    ...WaiverSection_waiverConnection\n  }\n}\n\nfragment AdditionalInfoSection_event on event {\n  id\n  cuid\n  activity\n  description\n  eventWebsite\n  refundInfo\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    entryFee\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}}) {\n    priceOverride\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}}) {\n    priceOverride\n    id\n  }\n  eventPrograms {\n    defaultPrice\n    id\n  }\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  eventAdditionalInfos {\n    id\n    cuid\n    title\n    description\n  }\n}\n\nfragment AmenitiesSection_amenities on amenityConnection {\n  edges {\n    node {\n      id\n      cuid\n      name\n      info\n      imageUrl\n    }\n  }\n}\n\nfragment AmenitiesSection_event on event {\n  id\n  cuid\n  activity\n  eventAmenities {\n    id\n    cuid\n    amenityCuid\n  }\n}\n\nfragment AssessmentSection_event on event {\n  id\n  cuid\n}\n\nfragment AwardsSection_event on event {\n  id\n  cuid\n  activity\n  isSponsoredEvent\n}\n\nfragment BasicWaiverSection_event on event {\n  id\n  cuid\n  activity\n  hasGeneralWaivers\n  publishedAt\n  organizerCuid\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  organizer {\n    events(where: {deleted_at: {_is_null: true}}) {\n      eventBasicWaivers(distinct_on: [name]) {\n        id\n        name\n        fileRef\n        cuid\n      }\n      id\n    }\n    id\n  }\n  eventBasicWaivers(order_by: {created_at: asc}) {\n    id\n    name\n    fileRef\n    cuid\n    appliesToAllCategories\n    eventBasicWaiverCategories {\n      id\n      cuid\n      categoryCuid\n      eventBasicWaiverCuid\n    }\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n    cuid\n    name\n    eventDiscipline {\n      id\n      disciplineName\n    }\n  }\n}\n\nfragment CategoriesSection_event on event {\n  id\n  cuid\n  name\n  organizerCuid\n  created_at\n  slug\n  publishedAt\n  organizer {\n    slug\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n  eventDisciplines(order_by: {created_at: asc}) {\n    id\n    cuid\n    disciplineName\n    fieldLimit\n    courses {\n      id\n    }\n    categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n      id\n    }\n  }\n}\n\nfragment CategoryPresetContainer_event on event {\n  id\n  cuid\n  activity\n  organizer {\n    slug\n    stripeConnectAccount {\n      chargesEnabled\n      payoutsEnabled\n      id\n    }\n    id\n  }\n  courses(order_by: {created_at: asc}) {\n    cuid\n    eventDisciplineCuid\n    fullName\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n    cuid\n    additionalPrizes\n    ageAsOf\n    description\n    entryFee\n    eventDisciplineCuid\n    eventCuid\n    gender\n    maxAge\n    minAge\n    name\n    position\n    abilityLevelRange\n    spotsAvailable\n    visible\n    eventDiscipline {\n      id\n      disciplineName\n    }\n    eventScheduleCategories {\n      id\n      cuid\n      eventScheduleCuid\n    }\n    categoryCourses {\n      id\n      cuid\n      courseCuid\n      category {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment ChecklistSection_event on event {\n  id\n  cuid\n  activity\n  eventChecklistItems {\n    id\n    cuid\n    name\n    info\n  }\n}\n\nfragment CourseSection_event on event {\n  id\n  cuid\n  name\n  activity\n  isCourseEvent\n  organizerCuid\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  courses(order_by: {created_at: asc}) {\n    id\n    platform\n    platformId\n    platformUrl\n    cuid\n    name\n    fullName\n    description\n    difficultyName\n    eventDisciplineCuid\n    eventCuid\n    courseLength\n    courseLengthType\n    courseLengthSecondary\n    courseLengthTypeSecondary\n    totalElevationGain\n    totalElevationLoss\n    elevationUnit\n    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {\n      category {\n        registrationCategories_aggregate(where: {registration: {status: {_eq: complete}}}) {\n          aggregate {\n            count\n          }\n        }\n        id\n      }\n      id\n    }\n    eventDiscipline {\n      id\n      disciplineName\n    }\n  }\n  eventDisciplines(order_by: {created_at: asc}) {\n    id\n    cuid\n    disciplineName\n    courses {\n      id\n    }\n  }\n}\n\nfragment CoursesColumn_event on event {\n  courses(order_by: {created_at: asc}) {\n    id\n    cuid\n    name\n    fullName\n    eventDisciplineCuid\n    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {\n      id\n      cuid\n      courseCuid\n      categoryCuid\n    }\n  }\n}\n\nfragment CreateCategoryDialog_event on event {\n  id\n  cuid\n  currencyCode\n  organizer {\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n  courses(order_by: {created_at: asc}) {\n    id\n    cuid\n    name\n    fullName\n    eventDisciplineCuid\n    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {\n      id\n      cuid\n      courseCuid\n      categoryCuid\n    }\n  }\n}\n\nfragment CustomQuestionsContainer_event on event {\n  id\n  cuid\n  activity\n  eventCustomQuestions(order_by: {position: asc}) {\n    id\n    cuid\n    eventCuid\n    internalPurpose\n    additionalInfo\n    isRequired\n    questionType\n    title\n    position\n    appliesToAllCategories\n    eventCustomQuestionCategories(where: {category: {deleted_at: {_is_null: true}}}) {\n      id\n      cuid\n      categoryCuid\n      eventCustomQuestionCuid\n      category {\n        id\n        name\n      }\n    }\n    eventCustomQuestionOptions(order_by: {position: asc}) {\n      id\n      cuid\n      name\n      position\n      eventCustomQuestionCuid\n    }\n  }\n}\n\nfragment DisciplineTabContainer_event on event {\n  id\n  cuid\n  courses(order_by: {created_at: asc}) {\n    id\n    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {\n      id\n      cuid\n    }\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n    cuid\n    additionalPrizes\n    ageAsOf\n    description\n    entryFee\n    eventDisciplineCuid\n    eventCuid\n    gender\n    maxAge\n    minAge\n    name\n    position\n    abilityLevelRange\n    spotsAvailable\n    visible\n    registrationCategories(where: {registration: {status: {_eq: complete}}}, limit: 1) {\n      id\n    }\n    eventScheduleCategories {\n      id\n      cuid\n      eventScheduleCuid\n    }\n    categoryCourses {\n      id\n      cuid\n      courseCuid\n      categoryCuid\n    }\n  }\n}\n\nfragment DisciplineTable_event on event {\n  id\n  cuid\n  currencyCode\n  startDate\n  organizer {\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n}\n\nfragment EditEventNameDialog_event on event {\n  cuid\n  eventMetadata {\n    cuid\n    name\n    slug\n    isCategoriedEvent\n    organizer {\n      slug\n      cuid\n      id\n    }\n    id\n  }\n}\n\nfragment EditMultipleCategories_event on event {\n  id\n  cuid\n  currencyCode\n  organizer {\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n  courses(order_by: {created_at: asc}) {\n    id\n    cuid\n    name\n    fullName\n    eventDisciplineCuid\n    categoryCourses(where: {category: {deleted_at: {_is_null: true}}}) {\n      id\n      cuid\n      courseCuid\n      categoryCuid\n    }\n  }\n}\n\nfragment EventCapacityContainer_event on event {\n  cuid\n  spotsAvailable\n  organizer {\n    slug\n    id\n  }\n  completeAndInProgressRegistrations: registrations_aggregate(where: {_and: [{status: {_in: [complete, in_progress]}}, {_not: {registrationCategories: {categoryCuid: {_is_null: true}}}}]}) {\n    aggregate {\n      count\n    }\n  }\n}\n\nfragment FinishSection_event on event {\n  isEventCreationComplete\n}\n\nfragment GeneralSection_event on event {\n  id\n  cuid\n  activity\n  currencyCode\n  endDate\n  startDate\n  eventAccess\n  organizerCuid\n  publishedAt\n  isVirtualEvent\n  occurrenceLabel\n  eventMetadata {\n    name\n    isCategoriedEvent\n    numberOfDays\n    id\n  }\n  eventVirtualVenues {\n    timezone\n    id\n  }\n  eventVenues {\n    venue {\n      timezone\n      id\n    }\n    id\n  }\n  organizer {\n    slug\n    cuid\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}}) {\n    id\n    cuid\n    clinicDays {\n      startTime\n      eventClinicDayDuration {\n        duration\n        id\n      }\n      id\n    }\n  }\n  eventClinicDayDurations {\n    id\n    cuid\n    dayNumber\n    duration\n  }\n  eventDisciplines(order_by: {created_at: asc}) {\n    id\n    cuid\n    disciplineName\n    categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n      id\n      name\n      eventDiscipline {\n        disciplineName\n        id\n      }\n      registrationCategories(limit: 1) {\n        id\n      }\n    }\n    courses {\n      id\n      name\n      cuid\n      eventDiscipline {\n        disciplineName\n        id\n      }\n    }\n  }\n}\n\nfragment HeaderContainer_event on event {\n  activity\n  startDate\n  endDate\n  lastSavedAt\n  canceledAt\n  isEventCreationComplete\n  registrations_aggregate(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}]}) {\n    aggregate {\n      count\n    }\n  }\n  eventMetadata {\n    cuid\n    name\n    isCategoriedEvent\n    events(where: {deleted_at: {_is_null: true}}) {\n      cuid\n      id\n    }\n    id\n  }\n}\n\nfragment HostEventMainView_event on event {\n  endDate\n  activity\n  canceledAt\n  registrations_aggregate(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}]}) {\n    aggregate {\n      count\n    }\n  }\n}\n\nfragment HostEventPage_event on event {\n  occurrenceLabel\n  eventMetadata {\n    name\n    id\n  }\n}\n\nfragment ImagesSection_event on event {\n  id\n  cuid\n  activity\n  eventImages(order_by: {position: asc}) {\n    id\n    cuid\n    position\n    eventCuid\n    imagePublicId\n    image {\n      bytes\n      format\n      height\n      originalFilename\n      organizerCuid\n      publicId\n      relativeUrl\n      resourceType\n      url\n      version\n      width\n      id\n    }\n  }\n}\n\nfragment IntroSection_event on event {\n  occurrenceLabel\n  eventMetadata {\n    name\n    id\n  }\n  activity\n}\n\nfragment LocationContactSection_event on event {\n  id\n  cuid\n  isVirtualEvent\n  additionalContactInfo\n  activity\n  email\n  lastSavedAt\n  organizerCuid\n  name\n  phone\n  publishedAt\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  eventVirtualVenues {\n    cuid\n    timezone\n    id\n  }\n  eventVenues {\n    id\n    meetupInstructions\n    additionalInfo\n    campingDescription\n    parkingInfo\n    cuid\n    eventCuid\n    venue {\n      id\n      cuid\n      name\n      placeId\n      lat\n      lng\n      organizerCuid\n      fullAddress\n      addressWithName\n      address\n      city\n      state\n      country\n      countryCode\n      postalCode\n      timezone\n    }\n  }\n}\n\nfragment MerchandiseSection_event on event {\n  id\n  cuid\n  currencyCode\n  hasMerchandise\n  eventMerchandises(where: {merchandise: {deleted_at: {_is_null: true}}}) {\n    id\n    visible\n    availableTo\n    cuid\n    merchandise {\n      id\n      cuid\n      title\n      description\n      deliveryType\n      price\n      stock\n      merchandiseImages {\n        id\n        cuid\n        isDefault\n        image {\n          bytes\n          format\n          height\n          originalFilename\n          publicId\n          relativeUrl\n          resourceType\n          url\n          version\n          width\n          organizerCuid\n          id\n        }\n      }\n      merchandiseVariantOptions {\n        id\n        cuid\n        optionName\n        merchandiseVariantOptionValues {\n          id\n          cuid\n          value\n          merchandiseVariantOptionCuid\n        }\n      }\n      merchandiseVariants {\n        id\n        cuid\n        merchandiseCuid\n        optionCuidValueCuid\n        stock\n        price\n        image {\n          bytes\n          format\n          height\n          originalFilename\n          publicId\n          relativeUrl\n          resourceType\n          url\n          version\n          width\n          organizerCuid\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment OccurrenceInfo_event on event {\n  organizerCuid\n  occurrenceLabel\n  endDate\n  registrations_aggregate(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}]}) {\n    aggregate {\n      count\n    }\n  }\n  eventMetadata {\n    name\n    id\n  }\n}\n\nfragment OccurrencesDialog_event on event {\n  organizerCuid\n  eventMetadata {\n    cuid\n    events(where: {deleted_at: {_is_null: true}}) {\n      cuid\n      startDate\n      endDate\n      lastSavedAt\n      canceledAt\n      publishedAt\n      cancellationReason\n      occurrenceLabel\n      registrations(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}, {event: {deleted_at: {_is_null: true}}}]}) {\n        userId\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment PricingSection_event on event {\n  id\n  cuid\n  startDate\n  endDate\n  regOpenDate\n  regCloseDate\n  hasDynamicPricing\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n    cuid\n    name\n    entryFee\n  }\n  eventPricingDates(order_by: {date: asc}) {\n    id\n    cuid\n    date\n    eventCuid\n  }\n  eventPricingChanges {\n    id\n    cuid\n    amount\n    eventPricingDateCuid\n    eventPricingGroupCuid\n    eventCuid\n  }\n  eventPricingGroups {\n    id\n    cuid\n    name\n    eventCuid\n    eventPricingGroupCategories {\n      id\n      cuid\n      eventPricingGroupCuid\n      categoryCuid\n      category {\n        id\n        cuid\n        name\n        entryFee\n      }\n    }\n  }\n}\n\nfragment ProgramSection_event on event {\n  id\n  cuid\n  currencyCode\n  organizer {\n    stripeConnectAccount {\n      chargesEnabled\n      payoutsEnabled\n      id\n    }\n    id\n  }\n  eventPrograms {\n    id\n    cuid\n    overview\n    skills\n    focus\n    genders\n    ageRange\n    abilityLevelRange\n  }\n}\n\nfragment PromoCodesContainer_event on event {\n  id\n  cuid\n  activity\n  currencyCode\n  regCloseDate\n  regOpenDate\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  eventPromoCodes {\n    id\n    cuid\n    eventCuid\n    amountOff\n    percentOff\n    code\n    codesAvailable\n    validFrom\n    validTo\n    isInactive\n  }\n  eventVenues {\n    venue {\n      timezone\n      id\n    }\n    id\n  }\n  eventVirtualVenues {\n    timezone\n    id\n  }\n}\n\nfragment RegistrationSection_event on event {\n  id\n  cuid\n  activity\n  startDate\n  endDate\n  regOpenDate\n  regCloseDate\n  selfEditEndDate\n  isRegistrationPaused\n  nonCategoriedRegDeadline\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  eventVenues {\n    venue {\n      timezone\n      id\n    }\n    id\n  }\n}\n\nfragment SanctionSection_event on event {\n  id\n  cuid\n  name\n  activity\n  publishedAt\n  isSanctionedEvent\n  organizerCuid\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n    cuid\n    name\n    eventDiscipline {\n      id\n      disciplineName\n    }\n  }\n  eventSanctions {\n    id\n    cuid\n    eventCuid\n    otherSanctionName\n    permit\n    sanctionCuid\n    appliesToAllCategories\n    allowOneDayLicense\n    isLicenseRequired\n    oneDayFee\n    eventSanctionCategories {\n      id\n      cuid\n      categoryCuid\n      eventSanctionCuid\n    }\n    sanction {\n      id\n      cuid\n      name\n      hasPermit\n      waiverLink\n      isOneDayAvailable\n      country\n      website\n      oneDayFee\n    }\n  }\n}\n\nfragment SanctionSection_sanctions on sanctionConnection {\n  edges {\n    node {\n      id\n      cuid\n      name\n      hasPermit\n      country\n      isOneDayAvailable\n      oneDayFee\n      waiverLink\n      website\n    }\n  }\n}\n\nfragment SaveCustomQuestionDialog_event on event {\n  id\n  cuid\n  activity\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n    cuid\n    name\n    eventDiscipline {\n      id\n      disciplineName\n    }\n  }\n}\n\nfragment SaveScheduleItemDialog_scheduleTypePreset on scheduleTypePresetConnection {\n  edges {\n    node {\n      id\n      cuid\n      type\n      activity\n      color\n      isPreset\n    }\n  }\n}\n\nfragment ScheduleClinicDialog_event on event {\n  id\n  cuid\n  activity\n  currencyCode\n  isVirtualEvent\n  eventVirtualVenues {\n    timezone\n    id\n  }\n  eventVenues {\n    venue {\n      timezone\n      id\n    }\n    id\n  }\n  eventClinicDayDurations {\n    cuid\n    dayNumber\n    duration\n    id\n  }\n  eventPrograms {\n    defaultPrice\n    ageRange\n    id\n  }\n  organizer {\n    slug\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    userOrganizerRoles {\n      user {\n        id\n        firstName\n        lastName\n        timezone\n        slug\n        stripeConnectAccount {\n          payoutsEnabled\n          chargesEnabled\n          id\n        }\n        coachCuid\n        coach {\n          id\n          cuid\n          user {\n            firstName\n            lastName\n            timezone\n            id\n          }\n          coachUnavailableDates {\n            id\n            cuid\n            date\n            startSeconds\n            endSeconds\n            isAllDay\n          }\n          coachAvailabilities {\n            cuid\n            dayOfTheWeek\n            isAvailable\n            startSeconds\n            endSeconds\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}}) {\n    clinicDays {\n      startTime\n      eventClinicDayDuration {\n        duration\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ScheduleClinicSection_event on event {\n  id\n  cuid\n  activity\n  currencyCode\n  isVirtualEvent\n  organizer {\n    slug\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n    userOrganizerRoles {\n      user {\n        id\n        coach {\n          id\n        }\n      }\n      id\n    }\n  }\n  eventClinicDayDurations {\n    cuid\n    dayNumber\n    duration\n    id\n  }\n  eventPrograms {\n    id\n    cuid\n    defaultPrice\n  }\n  clinics(where: {canceledAt: {_is_null: true}}) {\n    id\n    cuid\n    eventCuid\n    priceOverride\n    canceledAt\n    cancellationReason\n    spotsAvailable\n    meetingLink\n    registrationStatus\n    registrations_aggregate(where: {status: {_eq: complete}}) {\n      aggregate {\n        count\n      }\n    }\n    event {\n      isVirtualEvent\n      eventVirtualVenues {\n        timezone\n        id\n      }\n      eventVenues {\n        venue {\n          timezone\n          id\n        }\n        id\n      }\n      eventPrograms {\n        defaultPrice\n        ageRange\n        id\n      }\n      eventClinicDayDurations {\n        cuid\n        dayNumber\n        duration\n        id\n      }\n      organizer {\n        userOrganizerRoles {\n          user {\n            id\n            firstName\n            lastName\n            timezone\n            slug\n            coachCuid\n            stripeConnectAccount {\n              payoutsEnabled\n              chargesEnabled\n              id\n            }\n            coach {\n              id\n              cuid\n              user {\n                firstName\n                lastName\n                timezone\n                id\n              }\n              coachUnavailableDates {\n                id\n                cuid\n                date\n                startSeconds\n                endSeconds\n                isAllDay\n              }\n              coachAvailabilities {\n                cuid\n                dayOfTheWeek\n                isAvailable\n                startSeconds\n                endSeconds\n                id\n              }\n            }\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n    clinicDays {\n      cuid\n      startTime\n      eventClinicDayDurationCuid\n      eventClinicDayDuration {\n        cuid\n        dayNumber\n        duration\n        id\n      }\n      id\n    }\n    clinicCoaches {\n      cuid\n      clinicCuid\n      coachCuid\n      id\n    }\n  }\n}\n\nfragment ScheduleRideDialog_event on event {\n  id\n  cuid\n  activity\n  currencyCode\n  occurrenceLabel\n  isVirtualEvent\n  eventMetadata {\n    name\n    numberOfDays\n    id\n  }\n  organizer {\n    slug\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n  eventVenues {\n    venue {\n      timezone\n      id\n    }\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}}) {\n    created_at\n    priceOverride\n    rideDays {\n      startTime\n      id\n    }\n    id\n  }\n}\n\nfragment ScheduleRideSection_event on event {\n  id\n  cuid\n  activity\n  currencyCode\n  organizer {\n    slug\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n  startDate\n  endDate\n  eventVenues {\n    venue {\n      timezone\n      id\n    }\n    id\n  }\n  eventVirtualVenues {\n    timezone\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}}) {\n    id\n    cuid\n    eventCuid\n    priceOverride\n    canceledAt\n    cancellationReason\n    spotsAvailable\n    registrationStatus\n    dayOfContact\n    registrations_aggregate(where: {status: {_eq: complete}}) {\n      aggregate {\n        count\n      }\n    }\n    event {\n      occurrenceLabel\n      eventMetadata {\n        name\n        numberOfDays\n        id\n      }\n      eventVenues {\n        venue {\n          timezone\n          id\n        }\n        id\n      }\n      id\n    }\n    rideDays {\n      cuid\n      startTime\n      id\n    }\n  }\n}\n\nfragment ScheduleSection_event on event {\n  id\n  cuid\n  activity\n  startDate\n  eventVenues {\n    venue {\n      timezone\n      id\n    }\n    id\n  }\n  eventVirtualVenues {\n    timezone\n    id\n  }\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n    cuid\n    name\n    eventDiscipline {\n      id\n      disciplineName\n    }\n  }\n  eventScheduleTypeCustoms {\n    id\n    cuid\n    type\n    color\n    isPreset\n  }\n  eventScheduleDates(order_by: {date: asc}) {\n    id\n    cuid\n    date\n    dayNumber\n    eventSchedules {\n      id\n      cuid\n      title\n      startTime\n      endTime\n      description\n      addedInternally\n      appliesToAllCategories\n      eventScheduleDateCuid\n      eventScheduleTypeCustom {\n        id\n        cuid\n        type\n        color\n        isPreset\n      }\n      eventScheduleTypePreset {\n        id\n        cuid\n        isPreset\n        scheduleTypePresetCuid\n        scheduleTypePreset {\n          id\n          cuid\n          type\n          color\n          isPreset\n        }\n      }\n      eventScheduleCategories {\n        id\n        cuid\n        categoryCuid\n        eventScheduleCuid\n      }\n    }\n  }\n}\n\nfragment ScheduleTypePicker_event on event {\n  activity\n  eventScheduleTypeCustoms {\n    id\n    cuid\n    eventCuid\n    color\n    isPreset\n    type\n  }\n}\n\nfragment SeriesSection_event on event {\n  id\n  cuid\n  name\n  activity\n  publishedAt\n  isSeriesEvent\n  organizerCuid\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n    cuid\n    name\n    eventDiscipline {\n      id\n      disciplineName\n    }\n  }\n  eventSeries(where: {deleted_at: {_is_null: true}}) {\n    id\n    cuid\n    eventCuid\n    seriesCuid\n    roundNumber\n    appliesToAllCategories\n    eventSeriesCategories {\n      id\n      cuid\n      categoryCuid\n      eventSeriesCuid\n    }\n    event {\n      id\n      cuid\n      occurrenceLabel\n      eventMetadata {\n        name\n        isCategoriedEvent\n        id\n      }\n    }\n    series {\n      id\n      cuid\n      name\n      slug\n      description\n      seriesActivity\n      organizerCuid\n      totalRounds\n      isJoinable\n      joinKey\n      eventSeries(where: {deleted_at: {_is_null: true}}) {\n        id\n        cuid\n        eventCuid\n        seriesCuid\n        roundNumber\n        appliesToAllCategories\n        event {\n          id\n          cuid\n          occurrenceLabel\n          eventMetadata {\n            name\n            isCategoriedEvent\n            id\n          }\n        }\n        eventSeriesCategories {\n          id\n          cuid\n          categoryCuid\n          eventSeriesCuid\n        }\n      }\n      seriesImages {\n        isDefault\n        id\n        cuid\n        image {\n          bytes\n          format\n          height\n          originalFilename\n          publicId\n          relativeUrl\n          resourceType\n          url\n          version\n          width\n          organizerCuid\n          id\n        }\n      }\n      seriesPointsStructureCustoms {\n        id\n        cuid\n        isPreset\n        isQualifying\n        points\n        pointsName\n      }\n      seriesPointsStructurePresets {\n        id\n        presetCuid\n        isPreset\n      }\n    }\n  }\n}\n\nfragment SponsorTierItem_sponsors on sponsorConnection {\n  edges {\n    node {\n      id\n      cuid\n      name\n      website\n      sponsorImages {\n        id\n        cuid\n        isDefault\n        image {\n          id\n          bytes\n          format\n          height\n          originalFilename\n          organizerCuid\n          publicId\n          relativeUrl\n          resourceType\n          url\n          version\n          width\n        }\n      }\n    }\n  }\n}\n\nfragment SponsorsSection_event on event {\n  id\n  cuid\n  activity\n  isSponsoredEvent\n  eventSponsors(order_by: {position: asc}) {\n    id\n    cuid\n    tierName\n    position\n    sponsor {\n      id\n      cuid\n      name\n      website\n      sponsorImages {\n        id\n        cuid\n        isDefault\n        image {\n          id\n          bytes\n          format\n          height\n          originalFilename\n          organizerCuid\n          publicId\n          relativeUrl\n          resourceType\n          url\n          version\n          width\n        }\n      }\n    }\n  }\n}\n\nfragment TicketsSection_event on event {\n  id\n  cuid\n  activity\n  currencyCode\n  isTicketedEvent\n  organizer {\n    slug\n    stripeConnectAccount {\n      payoutsEnabled\n      chargesEnabled\n      id\n    }\n    id\n  }\n  eventTickets(where: {deleted_at: {_is_null: true}}) {\n    id\n    cuid\n    name\n    description\n    price\n    ticketsAvailable\n    visible\n    eventCuid\n    registrationTickets(where: {registration: {status: {_eq: complete}}}, limit: 1) {\n      id\n    }\n  }\n}\n\nfragment ValidityChecker_event on event {\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n}\n\nfragment VibeSection_event on event {\n  id\n  cuid\n  eventMetadata {\n    numberOfDays\n    id\n  }\n  eventVibes {\n    id\n    cuid\n    ridingTimePerDayRange\n    abilityLevelRange\n    hasAverageSpeed\n    averageSpeedRange\n    intensityRange\n    moreInfo\n    rideType\n    speedType\n    genders\n  }\n}\n\nfragment VirtualVenueContainer_event on event {\n  id\n  cuid\n  eventVirtualVenues {\n    id\n    cuid\n    timezone\n  }\n}\n\nfragment VolunteersSection_event on event {\n  id\n  cuid\n  hasVolunteers\n  eventVolunteerJobs(where: {deleted_at: {_is_null: true}}, order_by: [{title: asc}, {created_at: asc}]) {\n    id\n    cuid\n    title\n    description\n    locationInfo\n    eventCuid\n    eventVolunteerJobTasks {\n      id\n      cuid\n      volunteerTaskPriorityCuid\n      volunteerTaskPriority {\n        id\n        cuid\n        name\n        chipColor\n        className\n        color\n      }\n      volunteerTaskDifficultyCuid\n      volunteerTaskDifficulty {\n        id\n        cuid\n        name\n        chipColor\n        className\n        color\n      }\n      description\n      eventVolunteerJobCuid\n    }\n    eventVolunteerJobShifts {\n      id\n      cuid\n      name\n      eventVolunteerJobCuid\n      spotsAvailable\n      startDate\n      endDate\n      eventVolunteerJobShiftTasks {\n        id\n        cuid\n        eventVolunteerJobShiftCuid\n        eventVolunteerJobTaskCuid\n      }\n    }\n  }\n}\n\nfragment WaiverSection_event on event {\n  id\n  cuid\n  activity\n  hasGeneralWaivers\n  publishedAt\n  organizerCuid\n  eventWaivers(where: {type: {_eq: GENERAL}, waiver: {deleted_at: {_is_null: true}}}) {\n    waiver {\n      id\n      cuid\n      ownerType\n      latestRevision {\n        id\n        name\n        fileRef\n        cuid\n        fieldsConfiguration\n        revision\n      }\n    }\n    id\n  }\n  sanctions: eventSanctions {\n    cuid\n    sanction {\n      id\n      cuid\n      name\n    }\n    otherSanctionName\n    eventWaivers {\n      waiver {\n        cuid\n        id\n        ownerType\n        latestRevision {\n          id\n          name\n          fileRef\n          cuid\n          fieldsConfiguration\n          revision\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment WaiverSection_waiverConnection on waiverConnection {\n  edges {\n    node {\n      id\n      cuid\n      ownerType\n      sanctionWaivers {\n        sanction {\n          name\n          id\n        }\n        id\n      }\n      latestRevision {\n        cuid\n        fieldsConfiguration\n        fileRef\n        id\n        name\n        revision\n      }\n    }\n  }\n}\n\nfragment categoriesSectionSideEffects_customQuestionOnCategoryDelete_event on event {\n  id\n  cuid\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n  }\n  eventCustomQuestions(order_by: {position: asc}) {\n    id\n    cuid\n    eventCuid\n    internalPurpose\n    additionalInfo\n    isRequired\n    questionType\n    title\n    position\n    appliesToAllCategories\n    eventCustomQuestionCategories(where: {category: {deleted_at: {_is_null: true}}}) {\n      id\n    }\n  }\n}\n\nfragment categoriesSectionSideEffects_eventBasicWaiverOnCategoryDelete_event on event {\n  id\n  cuid\n  activity\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n  }\n  eventBasicWaivers(order_by: {created_at: asc}) {\n    cuid\n    name\n    fileRef\n    eventCuid\n    appliesToAllCategories\n    eventBasicWaiverCategories {\n      id\n      cuid\n    }\n    id\n  }\n}\n\nfragment categoriesSectionSideEffects_eventSanctionOnCategoryDelete_event on event {\n  id\n  cuid\n  activity\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n  }\n  eventSanctions {\n    cuid\n    eventCuid\n    sanctionCuid\n    appliesToAllCategories\n    eventSanctionCategories {\n      id\n      cuid\n    }\n    id\n  }\n}\n\nfragment categoriesSectionSideEffects_eventSeriesOnCategoryDelete_event on event {\n  id\n  cuid\n  activity\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n  }\n  eventSeries(where: {deleted_at: {_is_null: true}}) {\n    cuid\n    eventCuid\n    roundNumber\n    seriesCuid\n    appliesToAllCategories\n    eventSeriesCategories {\n      id\n      cuid\n    }\n    id\n  }\n}\n\nfragment categoriesSectionSideEffects_scheduleItemOnCategoryDelete_event on event {\n  id\n  cuid\n  activity\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    id\n  }\n  eventScheduleDates(order_by: {date: asc}) {\n    cuid\n    eventSchedules {\n      cuid\n      title\n      startTime\n      endTime\n      eventCuid\n      eventScheduleDateCuid\n      appliesToAllCategories\n      eventScheduleCategories {\n        id\n        cuid\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment generalSectionSideEffects_event on event {\n  id\n  cuid\n  activity\n  endDate\n  startDate\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n  eventScheduleDates(order_by: {date: asc}) {\n    id\n    cuid\n    date\n    dayNumber\n    eventCuid\n    eventSchedules {\n      id\n      cuid\n      title\n      startTime\n      endTime\n      eventCuid\n      addedInternally\n      eventScheduleDateCuid\n      eventScheduleTypePreset {\n        id\n        cuid\n        isPreset\n        scheduleTypePresetCuid\n        scheduleTypePreset {\n          id\n          cuid\n          type\n          color\n          isPreset\n        }\n      }\n    }\n  }\n}\n\nfragment helpers_getEncodedEventId_event on event {\n  id\n}\n\nfragment helpers_getEncodedEventMetadataId_event on event {\n  eventMetadata {\n    id\n  }\n}\n\nfragment helpers_getEventActivity_event on event {\n  activity\n}\n\nfragment helpers_getEventCuid_event on event {\n  cuid\n}\n\nfragment helpers_getEventLink_event on event {\n  cuid\n  eventMetadata {\n    slug\n    id\n  }\n  organizer {\n    slug\n    id\n  }\n}\n\nfragment helpers_getEventSlug_event on event {\n  eventMetadata {\n    slug\n    id\n  }\n}\n\nfragment helpers_getIsEventPublished_event on event {\n  publishedAt\n}\n\nfragment helpers_getOrganizerCuid_event on event {\n  organizerCuid\n}\n\nfragment helpers_getUserTypeFromActivity_event on event {\n  activity\n}\n\nfragment helpers_useSyncSectionValidity_event on event {\n  cuid\n  activity\n  startDate\n  regCloseDate\n  isVirtualEvent\n  publishedAt\n  currencyCode\n  completedSections\n  occurrenceLabel\n  eventMetadata {\n    isCategoriedEvent\n    name\n    id\n  }\n  organizer {\n    cuid\n    id\n  }\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    entryFee\n    id\n  }\n  rides(where: {canceledAt: {_is_null: true}}) {\n    priceOverride\n    id\n  }\n  clinics(where: {canceledAt: {_is_null: true}}) {\n    priceOverride\n    id\n  }\n  eventPrograms {\n    defaultPrice\n    id\n  }\n}\n\nfragment helpers_useUpdateAlgoliaSearchIndexes_event on event {\n  publishedAt\n  eventMetadata {\n    isCategoriedEvent\n    id\n  }\n}\n\nfragment hostEventMutations_useUnPublishEventMutation_event on event {\n  registrations(where: {_and: [{_or: [{status: {_eq: complete}}, {status: {_eq: canceled}}]}, {event: {deleted_at: {_is_null: true}}}]}) {\n    userId\n    id\n  }\n}\n\nfragment rulesCategories_RuleAllCategoriesHaveCourse_event on event {\n  id\n  cuid\n  categories(where: {deleted_at: {_is_null: true}}, order_by: {position: asc}) {\n    cuid\n    name\n    categoryCourses {\n      id\n      cuid\n    }\n    id\n  }\n}\n\nfragment rulesDates_RuleEventEndAfterRegClose_event on event {\n  id\n  cuid\n  activity\n  endDate\n  regCloseDate\n}\n\nfragment rulesDates_RuleScheduleDatesInsideEventDate_event on event {\n  id\n  cuid\n  endDate\n  startDate\n  eventScheduleDates(order_by: {date: asc}) {\n    cuid\n    date\n    dayNumber\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '05ead889a71a71567b8fdf513adfe4c9';
export default node;
